'use strict';
app.factory("cacheService", ['$rootScope', '$http', 'authService', '$compile', function ($rootScope, $http, authService, $compile)
{
    //cache versioning info
    let _initializeDate = new Date();    //set validity to maximum of 2 weeks
    let _initializeSeed = 20;            //increment this value to discard cache
    let _IDBInfo = {};                   //object storing cache versioning info
    Object.defineProperties(_IDBInfo, {
        enableIndexedDB: {
            //value: false,
            value: (!!window.indexedDB),
            //allow only this to be writable as it can be disabled on runtime by design
            writable: true
        },
        IndexedDBVer: {
            value: (_initializeDate.getUTCFullYear() * 1000) + ((_initializeDate.getUTCMonth() + 1) * 10) + (_initializeDate.getUTCDate() > 15 ? 2 : 1) + _initializeSeed,
            writable: false
        },
        DataTableName: {
            value: "DataTable",
            writable: false
        },
        PerfIndexedDBVer: {
            value: (_initializeDate.getUTCFullYear() * 1000) + ((_initializeDate.getUTCMonth() + 1) * 10) + (_initializeDate.getUTCDate() > 15 ? 2 : 1) + _initializeSeed,
            writable: false
        },
        PerfDataTableName:
        {
            value: "DataTable",
            writable: false
        }
    });

    //  Cache configuration :
    //  List of available datasource
    //   1.uom
    //   2.payterm
    //   3.ccid         (EXCLUDE costcentertype = FA)
    //   4.currinfo
    //   5.grniacc
    //   6.bank
    //   7.cash
    //   8.ou
    //   9.coa          (EXCLUDE costcentertype = FA)
    //  10.contact
    //  11.block
    //  12.activity
    //  13.company
    //  14.gang
    //  15.empy         (empypermas)
    //  16.paycode
    //  17.mill
    //  18.vehicle
    //  19.attdcode
    //  20.post
    //  21.div
    //  22.store
    //  23.itemcat
    //  24.itemmas
    //  25.plantsource
    //  26.nurbatch
    //  27.plantmate
    //  28.dept
    //  29.addrem
    //  30.taxded       (checkroll/payroll de, not account's gst!!)
    //  31.aprvlvl
    //  32.acccat
    //  33.fin          (finglconfg)
    //  34.tax          (gst tax)
    //  35.terrain
    //  36.soiltype
    //  37.uncularea
    //  38.bgtprep
    //  39.facoa        (ONLY costcentertype = FA)
    //  40.faccid       (ONLY costcentertype = FA)
    //  41.allcoa       (ALL)
    //  42.allccid      (ALL)
    //  43.field
    //  44.stoconfg
    //  45.vegetype
    //  46.vege
    //  47.salesitem
    //  48.clientnotification
    //  49.wgitem
    //  50.type
    //  51.typeID
    //  52.bgt          (BGTconfg)
    //  53.blocktask
    //  (41) and (42) doesn't actually exist, it is concatenation from (2) + (40) and (9) + (39)
    let _DataSourceCollection = [
        {
            Name: "uom",
            Cache: true,
            Sort: { field: "UOMCode", dir: "asc" },
            Model: {
                id: "UOMKey",
                fields: {
                    UOMKey: { type: "number", editable: false, nullable: false },
                    UOMCode: { type: "string", editable: false, nullable: false },
                    UOMDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "UOM?$format=json&$select=UOMKey,OUKey,UOMCode,UOMDesc,Active,ClientKey,UOMCodeUOMDesc,OUCode,OUCodeOUDesc,Symbol",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "payterm",
            Cache: true,
            Sort: { field: "PayTermCode", dir: "asc" },
            Model: {
                id: "PayTermKey",
                fields: {
                    PayTermKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    PayTermCode: { type: "string", editable: false, nullable: false },
                    PayTermDesc: { type: "string", editable: false, nullable: false },
                    PayTermType: { type: "string", editable: false, nullable: false },
                    PayTermCodePayTermDesc: { type: "string", editable: false, nullable: false },
                    DueDay: { type: "number", editable: false, nullable: false },
                    DueMth: { type: "number", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "PayTerm?$format=json&$select=PayTermKey,ClientKey,OUKey,PayTermCode,PayTermDesc,PayTermType,PayTermTypeDesc,DueDay,DueMth,Active,PayTermCodePayTermDesc,OUDesc",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "currinfo",
            Cache: true,
            Sort: { field: "LocalCurrCode", dir: "asc" },
            Model: {
                id: "LocalCurrKey",
                fields: {
                    CompKey: { type: "string", editable: false, nullable: false },
                    IsMultiCurrency: { type: "boolean", editable: false, nullable: false },
                    LocalCurrKey: { type: "number", editable: false, nullable: false },
                    LocalCurrCode: { type: "string", editable: false, nullable: false },
                    LocalCurrDesc: { type: "string", editable: false, nullable: false },
                    TaxCurrKey: { type: "number", editable: false, nullable: false },
                    TaxCurrCode: { type: "string", editable: false, nullable: false },
                    TaxCurrDesc: { type: "string", editable: false, nullable: false },
                    TaxCurrSymb: { type: "string", editable: false, nullable: false },
                    GSTClaimAccKey: { type: "number", editable: false, nullable: false },
                    GSTClaimAccNum: { type: "string", editable: false, nullable: false },
                    GSTLiabilityAccKey: { type: "number", editable: false, nullable: false },
                    GSTLiabilityAccNum: { type: "string", editable: false, nullable: false },
                    LocalCurrSymb: { type: "string", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.financeWebApiUrl + "FIN/GetSingleCurrInfo?$format=json&$select=IsMultiCurrency,LocalCurrKey,LocalCurrCode,LocalCurrDesc,LocalCurrSymb,TaxCurrKey,TaxCurrCode,TaxCurrDesc,TaxCurrSymb,GSTClaimAccKey,GSTClaimAccNum,GSTLiabilityAccKey,GSTLiabilityAccNum,CompKey",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["grniacc", "crniacc"]
        },
        {
            Name: "grniacc",
            Cache: true,
            Sort: { field: "GRNIAccKey", dir: "asc" },
            Model: {
                id: "GRNIAccKey",
                fields: {
                    CompKey: { type: "number", editable: false, nullable: false },
                    GRNIAccKey: { type: "number", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.financeWebApiUrl + "FIN/GetGRNIAccKey?$format=json&$select=GRNIAccKey,CompKey",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "crniacc",
            Cache: true,
            Sort: { field: "CRNIAccKey", dir: "asc" },
            Model: {
                id: "CRNIAccKey",
                fields: {
                    CompKey: { type: "number", editable: false, nullable: false },
                    CRNIAccKey: { type: "number", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.financeWebApiUrl + "FIN/GetCRNIAccKey?$format=json&$select=CRNIAccKey,CompKey",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "bank",
            Cache: true,
            Sort: { field: "BankCode", dir: "asc" },
            Model: {
                id: "BankKey",
                fields: {
                    BankKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    BankCode: { type: "string", editable: false, nullable: false },
                    BankCodeBankDesc: { type: "string", editable: false, nullable: false },
                    BankAcc: { type: "string", editable: false, nullable: false },
                    BankDesc: { type: "string", editable: false, nullable: false },
                    CurrCode: { type: "string", editable: false, nullable: false },
                    PhyBankAcc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    EnableBulkPay: { type: "boolean", editable: false, nullable: false },
                    EnableOnlinePaySta: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Bank?$format=json&$select=BankKey,ClientKey,BankCode,BankName,BankDesc,Active,CtryKey,BankAccKey,CurrKey,CurrCode,CurrDesc,PhyBankAcc,BankAcc,CCIDTypeKey,CCIDKey,BNMCode,BNM,AccDesc,AccNumAccDesc,BankCodeBankDesc,BankOUKey,BICKey,StateKey,APOrgCode,PayStaSubmit,FormatCode,BankCompKey,EnableBulkPay,SwiftCode,EnableOnlinePaySta",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid"]
        },
        {
            Name: "cash",
            Cache: true,
            Sort: { field: "CashCode", dir: "asc" },
            Model: {
                id: "CashKey",
                fields: {
                    CashKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    CashAccKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    CashCode: { type: "string", editable: false, nullable: false },
                    CashAcc: { type: "string", editable: false, nullable: false },
                    CashDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Cash?$format=json&$select=CashKey,ClientKey,CashCode,CashName,CashDesc,Active,CashAccKey,CurrKey,CurrCode,CurrDesc,CashAcc,AccDesc,AccNumAccDesc,CashCodeCashDesc,CCIDTypeKey,CCIDKey,CashOUKey,CashCompKey",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid"]
        },
        {
            Name: "gang",
            Cache: true,
            Sort: { field: "GangCode", dir: "asc" },
            Model: {
                id: "GangKey",
                fields: {
                    GangKey: { type: "number", editable: false, nullable: false },
                    OUKey: { type: "number", editable: false, nullable: false },
                    GangCode: { type: "string", editable: false, nullable: false },
                    GangDesc: { type: "string", editable: false, nullable: false },
                    GangCodeGangDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Gang?$format=json&$select=GangKey,ClientKey,OUKey,CompKey,GangCode,GangDesc,Active,EmpyKey,CheckerKey,Checker,DefHarMdr,DefHarMdr2,DefHarMdrOUKey,DftHarPymtMtd,GangCodeGangDesc,EmpyIDEmpyName,EmpyIDEmpyName1,DefHarMdr2IDName,OUCodeOUDesc,OUCode",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "empy",
            Cache: true,
            Sort: { field: "EmpyID", dir: "asc" },
            Model: {
                id: "EmpyKey",
                fields: {
                    EmpyKey: { type: "number", editable: false, nullable: false },
                    EmpyIDEmpyName: { type: "string", editable: false, nullable: false },
                    GangKey: { type: "number", editable: false, nullable: false },
                    GangCode: { type: "string", editable: false, nullable: false },
                    DRate: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "EmpyPerMas?$format=json&$select=EmpyKey,EmpyID,EmpyName,EmpyIDEmpyName,GangKey,GangCode,GangCodeGangDesc,OUCodeOUDesc,OUCode,DRate,MRate,EnablePB,LProfileKey,OTProKey,FWBatchCode,EmplCat,FirstDayWork,LastDayWork,PRType,PostKey,PRTypeDesc,PostDesc,DeptKey,DeptCode,Status,EnableDP,EnableMP,EnableTax,OUKey,EnablePayPro,DeptCodeDeptDesc,EnableEmailPayslip,DivKey,Gender,GenderDesc,RaceKey,RaceDesc,NationalDesc,HiredDate,PostCodeDesc,GradeKey,GradeCodeDesc,EnableVL,ShiftProfKey",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "paycode",
            Cache: true,
            Sort: { field: "PayCode", dir: "asc" },
            Model: {
                id: "PayKey",
                fields: {
                    PayKey: { type: "number", editable: false, nullable: false, defaultValue: -1 },
                    PayCode: { type: "string", editable: false, nullable: false },
                    PayCodePayDesc: { type: "string", editable: false, nullable: false },
                    AccKey: { type: "number", editable: false, nullable: false, defaultValue: -1 },
                    AccNumAccDesc: { type: "string", editable: false, nullable: false },
                    CCIDKey: { type: "number", editable: false, nullable: false, defaultValue: -1 },
                    CCIDCodeCCIDDesc: { type: "string", editable: false, nullable: false },
                    IsRequiredCCID: { type: "boolean", editable: false, nullable: false },
                    IsAlwChangeRate: { type: "boolean", editable: false, nullable: false },
                    EnableProRate: { type: "boolean", editable: false, nullable: false },
                    DftAmt: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    Module: { type: "string", editable: false, nullable: false },
                    PayCodeType: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    RecTypeKey: { type: "number", editable: false, nullable: false, defaultValue: -1 },
                    RecTypeCodeRecTypeDesc: { type: "string", editable: false, nullable: false },
                    GrpType: { type: "string", editable: false, nullable: false },
                    GrpCode: { type: "string", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterWebApiUrl + "PayCode/GetPayCode?$format=json",
              //  url: $rootScope.masterOdataUrl + "PayCode?$format=json&$select=PayKey,OUKey,OUCode,PayCode,PayCodeType,PayDesc,Active,PayGrpKey,PayGrpCodeGrpDesc,GrpCode,EPFCont,TaxCont,SOCSOCont,DftAmt,AccKey,AccNum,AccNumAccDesc,CCIDKey,IsRequiredCCID,CCIDCode,CCIDCodeCCIDDesc,PayCodePayDesc,RecTypeKey,RecTypeCodeRecTypeDesc,IsTaxPPh,IsTaxAllow,TaxExpType,Module,GrpType,OTRate,IsAlwChangeRate,EnableProRate",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "mill",
            Cache: true,
            Sort: { field: "MillCode", dir: "asc" },
            Model: {
                id: "MillKey",
                fields: {
                    MillKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    MillCode: { type: "string", editable: false, nullable: false },
                    MillCodeDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Mill?$format=json&$select=MillKey,MillCode,MillDesc,Active,MillType,ClientKey,OUKey,ContactKey,Remarks,MillCodeDesc,MillOUKey",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "veh",
            Cache: true,
            Sort: { field: "VehID", dir: "asc" },
            Model: {
                id: "VehKey",
                fields: {
                    VehKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    ClientKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    RegNo: { type: "string", editable: false, nullable: false },
                    VehIDVehDesc: { type: "string", editable: false, nullable: false },
                    VehID: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                //url: $rootScope.masterOdataUrl + "Veh?$format=json&$select=VehKey,VehTypeKey,VehID,VehDesc,Active,PriUOMKey,FuelUOMKey,SecUOMKey,LocKey,RegNo,MthPurchased,YrMade,Make,Model,EngineCC,SerialNo,EngineVIN,ChasisVIN,TyreFront,TyreRear,RdExpiredDate,HasCL,CLDate,HasJPJ,JPJDate,HasNS,NSDate,Remarks,TrnFrom,TrnTo,TrnDate,ServInterval,LastMeter,OUKey,ClientKey,CompKey,VehTypeCode,LocDesc,OUDesc,OUCode,PriDesc,VehIdVehDesc,FuelDesc,SecDesc,CCIDTypeKey,PriUnitRate",
                url: $rootScope.masterOdataUrl + "Veh?$format=json&$select=VehKey,VehTypeKey,VehID,VehDesc,Active,RegNo,OUKey,ClientKey,CompKey,VehTypeCode,OUDesc,OUCode,VehIdVehDesc,CCIDTypeKey,PriUOMKey,FuelUOMKey,SecUOMKey,PriDesc,FuelDesc,SecDesc,PriUnitRate",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid"]
        },
        {
            Name: "attdcode",
            Cache: true,
            Sort: { field: "AttdCode", dir: "asc" },
            Model: {
                id: "AttdKey",
                fields: {
                    AttdKey: { type: "number", editable: false, nullable: false },
                    AttdCode: { type: "string", editable: false, nullable: false },
                    AttdCodeAttdDesc: { type: "string", editable: false, nullable: false },
                    ColorInd: { type: "string", editable: false, nullable: false },
                    PRType: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "AttdCode?$format=json&$select=AttdKey,ClientKey,AttdCode,AttdDesc,AttdCodeAttdDesc,Active,OUKey,OUCode,ColorInd,SeqNo,AttdTypeKey,PRType,PRTypeDesc,AllowPay,PayMtd,PayMtdDesc,PayRateMtd,PayRateMtdDesc,EnablePB,PBType,PBTypeDesc,IsIncMthAvgIncome,DPF,DPFString,AttdTypeCode,AttdTypeDesc,AttdTypeAllowPay,IsWrkDay,OUCodeOUDesc,EnableOT,EnableAllocOT,AllowEmptyPR,AllowZeroMD,MDDefaultVal,IsDutyCompleted,OfferDay,Type",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "post",
            Cache: true,
            Sort: { field: "PostCode", dir: "asc" },
            Model: {
                id: "PostKey",
                fields: {
                    PostKey: { type: "number", editable: false, nullable: false },
                    DivKey: { type: "number", editable: false, nullable: false },
                    PostCode: { type: "string", editable: false, nullable: false },
                    PostDesc: { type: "string", editable: false, nullable: false },
                    PostCodePostDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    PostOUKey: { type: "object", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Post?$format=json&$select=PostKey,PostCode,PostDesc,PostCodePostDesc,PostOUKey,Active",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "div",
            Cache: true,
            Sort: { field: "DivCode", dir: "asc" },
            Model: {
                id: "DivKey",
                fields: {
                    DivKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    DivCode: { type: "string", editable: false, nullable: false, dir: "asc" },
                    DivDesc: { type: "string", editable: false, nullable: false },
                    DivCodeDivDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Division?$format=json&$select=DivKey,ClientKey,OUKey,DivCode,DivDesc,Active,DivCodeDivDesc,OUCodeOUDesc,CompKey,CompCodeCompDesc,PlantedArea,GrossArea,OUCode",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid"]
        },
        {
            Name: "store",
            Cache: true,
            Sort: { field: "StoreCode", dir: "asc" },
            Model: {
                id: "StoreKey",
                fields: {
                    StoreKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    StoreCode: { type: "string", editable: false, nullable: false },
                    StoreDesc: { type: "string", editable: false, nullable: false },
                    StoreCodeStoreDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Store?$format=json&$select=StoreKey,StoreCode,StoreDesc,StoreCodeStoreDesc,ClientKey,Active,TransHierachy,IsMainStore,ClientCode,ClientName,OUKey,OUCode,OUDesc,CompKey,CompCode,CompDesc,CompCodeCompDesc,CCIDTypeKey",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid"]
        },
        {
            Name: "itemcat",
            Cache: true,
            Sort: { field: "ItemCatCode", dir: "asc" },
            Model: {
                id: "ItemCatKey",
                fields: {
                    ItemCatKey: { type: "number", nullable: false },
                    ItemCatCode: { type: "string", nullable: false },
                    ItemCatDesc: { type: "string", nullable: false },
                    ItemCatCodeCatDesc: { type: "string", nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    EnableAutoNo: { type: "boolean", editable: false, nullable: false },
                    NumLength: { type: "number", editable: false, nullable: false },
                    NextNum: { type: "number", editable: false, nullable: false },
                    Prefix: { type: "string", editable: false, nullable: false },
                    NextItemID: { type: "string", editable: false, nullable: false },
                    Type: { type: "string", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "ItemCat?$format=json&$select=ItemCatKey,ClientKey,ItemCatCode,ItemCatDesc,Active,ItemTypeKey,EnableAutoNo,NumLength,NextNum,NextItemID,ItemTypeDesc,ItemCatCodeCatDesc,Prefix,Type",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "itemmas",
            Cache: true,
            Sort: { field: "ItemID", dir: "asc" },
            Model: {
                id: "StoItemKey",
                fields: {
                    StoItemKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    ItemID: { type: "string", editable: false, nullable: false },
                    ItemDesc: { type: "string", editable: false, nullable: false },
                    ItemCatKey: { type: "number", editable: false, nullable: false },
                    ItemCatCode: { type: "string", editable: false, nullable: false },
                    ItemCatDesc: { type: "string", editable: false, nullable: false },
                    StoItemPhotoKey: { type: "number", editable: false, nullable: false },
                    ItemPhoto: { type: "byte[]", editable: false, nullable: false },
                    ItemIDItemDesc: { type: "string", editable: false, nullable: false },
                    ItemCatCodeCatDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "ItemMas?dummy=-1&dummy1=-1&StoItemKey=-1&$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "plantsource",
            Cache: true,
            Sort: { field: "PlantSourceCode", dir: "asc" },
            Model: {
                id: "PlantSourceKey",
                fields: {
                    PlantSourceKey: { type: "number", editable: false, nullable: false },
                    PlantSourceCode: { type: "string", editable: false, nullable: false },
                    PSCodePSDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "PlantSource?$format=json&$select=PlantSourceKey,PlantSourceCode,PlantSourceDesc,Active,PSCodePSDesc",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "nurbatch",
            Cache: true,
            Sort: { field: "NurBatchCode", dir: "asc" },
            Model: {
                id: "NurBatchKey",
                fields: {
                    NurBatchKey: { type: "number", editable: false, nullable: false },
                    NurBatchCode: { type: "string", editable: false, nullable: false },
                    NurBatchCodeDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "NurseryBatch?$format=json&$select=NurBatchKey,ClientKey,OUKey,NurBatchCode,NurBatchDesc,NurBatchCodeDesc,PlantMateCodeDesc,OUCodeOUDesc,OUCode,OUDesc,Active,PlantedYr,PlantedMth,PlantedYear,PlantedMonth,PlantMateKey,IsProgramComplete,IsAutoNurPreSold,IsAutoNurMainSold,IsAutoNurTransPlant,CompKey,CCIDTypeKey,PreNursaryAccKey,MainNursaryAccKey,ImmatureAccKey,MatureAccKey,TransferToFieldAccKey,CropKey,ProgramCompleteDate",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid"]
        },
        {
            Name: "plantmate",
            Cache: true,
            Sort: { field: "PlantMateCode", dir: "asc" },
            Model: {
                id: "PlantMateKey",
                fields: {
                    PlantMateKey: { type: "number", editable: false, nullable: false },
                    PlantMateCode: { type: "string", editable: false, nullable: false },
                    PMCodePMDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "PlantMate?$format=json&$select=PlantMateKey,PlantMateCode,PlantMateDesc,Active,PMCodePMDesc",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "dept",
            Cache: true,
            Sort: { field: "DeptCode", dir: "asc" },
            Model: {
                id: "DeptKey",
                fields: {
                    DeptKey: { type: "number", editable: false, nullable: false },
                    ClientKey: { type: "number", editable: false, nullable: false },
                    DeptCode: { type: "string", editable: false, nullable: false },
                    DeptDesc: { type: "string", editable: false, nullable: false },
                    DeptCodeDeptDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Dept?$format=json&$select=DeptKey,ClientKey,DeptCode,DeptDesc,DeptCodeDeptDesc,Active, DeptOUKey",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid", "aprvlvl"]
        },
        {
            Name: "addrem",
            Cache: true,
            Sort: { field: "AddRemCode", dir: "asc" },
            Model: {
                id: "AddRemKey",
                fields: {
                    AddRemKey: { type: "number", editable: false, nullable: false },
                    AddRemCode: { type: "string", editable: false, nullable: false },
                    AddRemDesc: { type: "string", editable: false, nullable: false },
                    AddRemCodeAddRemDesc: { type: "string", editable: false, nullable: false },
                    TypeDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    IsRequiredCCID: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "AddRem?$format=json&$select=OUKey,OUCode,AddRemKey,AddRemCodeAddRemDesc,Active,Type",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "taxded",
            Cache: true,
            Sort: { field: "SeqNo", dir: "asc" },
            Model: {
                id: "TaxDedKey",
                fields: {
                    TaxDedKey: { type: "number", editable: false, nullable: false },
                    TaxDedCode: { type: "string", editable: false, nullable: false },
                    TaxDedDesc: { type: "string", editable: false, nullable: false },
                    TaxDedCodeTaxDedDesc: { type: "string", editable: false, nullable: false },
                    DedAmt: { type: "number", editable: false, nullable: false, defaultValue: 0, validation: { min: 0 } },
                    Yr: { type: "number", editable: false, nullable: false },
                    Type: { type: "string", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.systemOdataUrl + "TaxDed?$format=json&$select=TaxDedKey,TaxDedCode,TaxDedDesc,Type,Amount,NoOfYears,Yr,TaxDedCodeTaxDedDesc,RefTaxDedKey",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "ou",
            Cache: true,
            Sort: { field: "OUCode", dir: "asc" },
            Model: {
                id: "OUKey",
                fields: {
                    CompKey: { type: "number", editable: false, nullable: false },
                    OUKey: { type: "number", editable: false, nullable: false },
                    OUCode: { type: "string", editable: false, nullable: false },
                    OUDesc: { type: "string", editable: false, nullable: false },
                    OUCodeOUDesc: { type: "string", editable: false, nullable: false },
                    EnableNoTaxChecking: { type: "boolean", editable: false, nullable: false },
                    GSTRegNo: { type: "string", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "UserInOU?$format=json&",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid", "faccid"]
        },
        {
            Name: "coa",
            Cache: true,
            Sort: { field: "AccNum", dir: "asc" },
            Model: {
                id: "AccKey",
                fields: {
                    AccKey: { type: "number", editable: false, nullable: false },
                    AccNum: { type: "string", editable: false, nullable: false },
                    AccDesc: { type: "string", editable: false, nullable: false },
                    AccNumAccDesc: { type: "string", editable: false, nullable: false },
                    AccCatKey: { type: "number", editable: false, nullable: false },
                    AccType: { type: "string", editable: false, nullable: false },
                    AnlysType: { type: "string", editable: false, nullable: false },
                    OperationTypeDesc: { type: "number", editable: false, nullable: true },
                    IsVFuelAcc: { type: "boolean", editable: false, nullable: false },
                    IsVLubAcc: { type: "boolean", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    AccMasOUKey: { type: "object", editable: false, nullable: false },
                    AccSubCatKey: { type: "number", editable: false, nullable: false },
                    CropKey: { type: "number", editable: false, nullable: false },
                    AccSubType: { type: "number", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "COA?isShowEverything=false&isShowFAonly=false&$format=json&$select=AccKey,AccNum,AccDesc,AccCatKey,AccCatSegKey,AccCatCode,AccCatDesc,AccType,AnlysType,AllowRevalue,OperationTypeKey,OperationTypeCode,OperationTypeDesc,IsVFuelAcc,IsVLubAcc,ClientKey,Active,CFTypeKey,CFTypeDesc,AccNumAccDesc,IsRequiredCCID,CostCenterType,UOMKey,UOMCode,UOMCodeUOMDesc,IsControlAccount,AccMasOUKey,CropKey,AccSubCatKey,AccSubCatDetKey,AccSubType",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["facoa", "ccid", "faccid", "stoconfg"]
        },
        {
            Name: "contact",
            Cache: true,
            Sort: { field: "ContactCode", dir: "asc" },
            Model: {
                id: "ContactKey",
                fields: {
                    ContactKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    ClientKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    ContactCode: { type: "string", editable: false, nullable: false },
                    ContactDesc: { type: "string", editable: false, nullable: false },
                    ConCat: { type: "string", editable: false, nullable: false },
                    RcvAccNum: { type: "number", editable: false, nullable: false },
                    RcvAccDesc: { type: "string", editable: false, nullable: false },
                    PayAccNum: { type: "number", editable: false, nullable: false },
                    PaymentType: { type: "string", editable: false, nullable: false },
                    PayTermKey: { type: "number", editable: false, nullable: false },
                    PayTermCode: { type: "string", editable: false, nullable: false },
                    CurrKey: { type: "number", editable: false, nullable: false },
                    ContactOUKey: { type: "string", editable: false, nullable: false },
                    ContactCompKey: { type: "string", editable: false, nullable: false },
                    ContactCatDesc: { type: "string", editable: false, nullable: false },
                    BenDetails: { type: "object", editable: false, nullable: false },
                    IsOneTime: { type: "boolean", editable: false, nullable: false },
                    OneTimeType: { type: "string", editable: false, nullable: false },
                    CPerson: { type: "string", editable: false, nullable: false },
                    Position: { type: "string", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Contact?formName='All'&$select=BenDetails,ContactKey,ClientKey,ContactCode,ContactDesc,ConCat,ConCatDesc,RcvAccKey,RcvAccNum,RcvAccDesc,PayAccKey,PayAccNum,PayAccDesc,BusRegNo,GSTRegNo,PaymentType,PaymentTypeDesc,PayTermKey,PayTermCode,PayTermDesc,CurrKey,CurrCode,CurrDesc,Active,ContactCodeContactDesc,IsGSTCtrlAcc,ContactAccKey,ContactAccNum,ContactAccDesc,ContactOUKey,ContactCompKey,CCIDTypeKey,CCIDKey,ContactCategory,ContactCatCode,ContactCatDesc,ContactCatCodeContactCatDesc,IsTaxRegistered,InterOUCompKey,ExcludeAging,Tier,BillStreet,BillPostCode,BillCity,BillState,BillCtryDesc,ShipStreet,ShipPostCode,ShipCity,ShipState,ShipCtryDesc,ContactType,IsOneTime,OneTimeType,CPerson,Position",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid"]
        },
        {
            Name: "block",
            Cache: true,
            Sort: { field: "BlockCode", dir: "asc" },
            Model: {
                id: "BlockKey",
                fields: {
                    BlockKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    BlockCode: { type: "string", editable: false, nullable: false },
                    BlockDesc: { type: "string", editable: false, nullable: false },
                    BlockCodeBlockDesc: { type: "string", editable: false, nullable: false },
                    DivKey: { type: "number", editable: false, nullable: false },
                    DivCode: { type: "string", editable: false, nullable: false },
                    DivDesc: { type: "string", editable: false, nullable: false },
                    FieldKey: { type: "number", editable: false, nullable: false },
                    FieldCode: { type: "string", editable: false, nullable: false },
                    FieldDesc: { type: "string", editable: false, nullable: false },
                    FieldCodeFieldDesc: { type: "string", editable: false, nullable: false },
                    EnableConvRate: { type: "boolean", editable: false, nullable: false },
                    EnableMacRate: { type: "boolean", editable: false, nullable: false },
                    HarRate: { type: "number", editable: false, nullable: false },
                    HarRate2: { type: "number", editable: false, nullable: false },
                    HarRate3: { type: "number", editable: false, nullable: false },
                    PlantedYr: { type: "number", editable: false, nullable: false },
                    PlantedMth: { type: "number", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    Maturity: { type: "string", editable: false, nullable: false },
                    OUKey: { type: "number", editable: false, nullable: false },
                    EnableHRPro: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Block?$format=json&$select=ClientKey,BlockKey,DivKey,FieldKey,BlockCode,BlockDesc,Active,GCAllot,PlantedYr,PlantedMth,FirstHARYr,FirstHARMth,PlantedArea,GrossArea,SPH,Maturity,MaturityDesc,BatchType,BatchTypeDesc,HarExpAccKey,LFExpAccKey,TallPalmImpAccKey,MachBuffAccKey,CropKey,PlantBatchKey,HarRate,HarRate2,HarRate3,DivCode,DivDesc,FieldCode,FieldDesc,FieldCodeFieldDesc,CropCode,CropDesc,PlantBatchCode,PlantBatchDesc,HarExpAccNum,HarExpAccDesc,LFExpAccNum,LFExpAccDesc,TallPalmImpAccNum,TallPalmImpAccDesc,MachBuffAccNum,MachBuffAccDesc,OUDesc,OUCode,OUKey,PlantBatchCodeDesc,CropCodeDesc,BlockCodeBlockDesc,CCIDTypeKey,CCIDKey,EnableConvRate,EnableMacRate,PlantSourceKey,PlantSourceCodeDesc,PlantMateKey,PlantMateCodeDesc,PlantDistance,TotalStand,HarConvAccKey,HarConvAccDesc,MacKey,MacCodeMacDesc,TallPalmKey,TallPalmCodeTallPalmDesc,EnableTallPalm,IsScoutHar,ScoutHarAccKey,ScoutHarAccDesc,TerrainKey,SoilTypeKey,SoilTypeCodeSoilTypeDesc,TerrainCodeTerrainDesc,DefRateType,EnableHRPro",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid"]
        },
        {
            Name: "activity",
            Cache: true,
            Sort: { field: "ACode", dir: "asc" },
            Model: {
                id: "ACodeKey",
                fields: {
                    ACodeKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    ClientKey: { type: "number", editable: false, nullable: false },
                    ACode: { type: "string", editable: false, nullable: false },
                    ACodeDesc: { type: "string", editable: false, nullable: false },
                    ACodeACodeDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    RcdType: { type: "number", editable: false, nullable: false },
                    RcdTypeDesc: { type: "string", editable: false, nullable: false },
                    UOMKey: { type: "number", editable: false, nullable: false },
                    UOM: { type: "string", editable: false, nullable: false },
                    UOMCodeUOMDesc: { type: "string", editable: false, nullable: false },
                    Category: { type: "string", editable: false, nullable: false },
                    CategoryCode: { type: "string", editable: false, nullable: false },
                    CategoryCodeDesc: { type: "string", editable: false, nullable: false },
                    DriverPer: { type: "number", editable: false, nullable: false },
                    Attd1Per: { type: "number", editable: false, nullable: false },
                    Attd2Per: { type: "number", editable: false, nullable: false },
                    UserDefine: { type: "boolean", editable: false, nullable: false },
                    OnePartition: { type: "boolean", editable: false, nullable: false },
                    TwoPartition: { type: "boolean", editable: false, nullable: false },
                    ThreePartition: { type: "boolean", editable: false, nullable: false },
                    IsCPToRamp: { type: "boolean", editable: false, nullable: false },
                    IsTransportation: { type: "boolean", editable: false, nullable: false },
                    IsAdopt: { type: "boolean", editable: false, nullable: false },
                    EnableManPRInc: { type: "boolean", editable: false, nullable: false },
                    ManPRIncRate: { type: "number", editable: false, nullable: false },
                    AdoptDPF: { type: "boolean", editable: false, nullable: false },
                    QtyConversion: { type: "string", editable: false, nullable: false },
                    ActivityType: { type: "string", editable: false, nullable: false },
                    CreatedBy: { type: "number", editable: false, nullable: false },
                    CreatedByCode: { type: "string", editable: false, nullable: false },
                    CreatedDate: { type: "date", editable: false, nullable: false },
                    UpdatedBy: { type: "number", editable: false, nullable: false },
                    UpdatedByCode: { type: "string", editable: false, nullable: false },
                    UpdatedDate: { type: "date", editable: false, nullable: false },
                    activityOUDetails: { type: "object", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterWebApiUrl + "Activity?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "company",
            Cache: true,
            Sort: { field: "CompCode", dir: "asc" },
            Model: {
                id: "CompKey",
                fields: {
                    CompKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    ClientKey: { type: "number", editable: false, nullable: false },
                    ClientCode: { type: "string", editable: false, nullable: false },
                    ClientCodeClientName: { type: "string", editable: false, nullable: false },
                    CompCodeCompDesc: { type: "string", editable: false, nullable: false },
                    RegNo: { type: "string", editable: false, nullable: false },
                    GSTRegNo: { type: "string", editable: false, nullable: false },
                    SOCSONo: { type: "string", editable: false, nullable: false },
                    TaxNo: { type: "string", editable: false, nullable: false },
                    EmprID: { type: "string", editable: false, nullable: false },
                    GrpKey: { type: "number", editable: false, nullable: false },
                    GrpCode: { type: "string", editable: false, nullable: false },
                    GrpCodeGrpDesc: { type: "string", editable: false, nullable: false },
                    CompCode: { type: "string", editable: false, nullable: false },
                    CompDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    OUCount: { type: "number", editable: false, nullable: false },
                    TaxCurrKey: { type: "number", editable: false, nullable: false },
                    FuncCurrKey: { type: "number", editable: false, nullable: false },
                    LocalCurrKey: { type: "number", editable: false, nullable: false },
                    ConvertType: { type: "string", editable: false, nullable: false },
                    CtryKey: { type: "number", editable: false, nullable: false },
                    IsOUTaxCentric: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Company?$format=json&",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["currinfo", "stoconfg"]
        },
        {
            Name: "aprvlvl",
            Cache: true,
            Sort: { field: "Subject", dir: "asc" },
            Model: {
                id: "Index",
                fields: {
                    Index: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    ApprovalSubjectKey: { type: "number", editable: false, nullable: false },
                    Subject: { type: "string", editable: false, nullable: false },
                    SubjectDesc: { type: "string", editable: false, nullable: false },
                    ApprovalPolicy: { type: "string", editable: false, nullable: false },
                    ApprovalBy: { type: "string", editable: false, nullable: false },
                    ClientKey: { type: "number", editable: false, nullable: false },
                    CompKey: { type: "number", editable: false, nullable: false },
                    OUKey: { type: "number", editable: false, nullable: false },
                    DeptKey: { type: "number", editable: false, nullable: false },
                    Level: { type: "number", editable: false, nullable: false },
                    Weightage: { type: "number", editable: false, nullable: false },
                    LowerLimit: { type: "number", editable: false, nullable: false },
                    UpperLimit: { type: "number", editable: false, nullable: false },
                    NoOfApproval: { type: "number", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.financeWebApiUrl + "FIN/GetApprovalSubject?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "ccid",
            Cache: true,
            Sort: { field: "CCIDCode", dir: "asc" },
            Model: {
                id: "CCIDKey",
                fields: {
                    CCIDCode: { type: "string", editable: false, nullable: false },
                    CCIDDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    OUList: { type: "object", editable: false, nullable: true },
                    AccList: { type: "object", editable: false, nullable: true },
                    AccCatList: { type: "object", editable: false, nullable: true },
                    CCTypeCodeList: { type: "object", editable: false, nullable: true },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "CCIDInfo?dummy=0&dummy1=0&$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["faccid"]
        },
        {
            Name: "acccat",
            Cache: true,
            Sort: [{ field: "AccCatCode", dir: "asc" }, { field: "AccCatDesc", dir: "asc" }],
            Model: {
                id: "AccCatKey",
                fields: {
                    AccCatKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    AccTypeCode: { type: "string", editable: false, nullable: false },
                    AccCatCode: { type: "string", editable: false, nullable: false },
                    AccCatDesc: { type: "string", editable: false, nullable: false },
                    CostCenterType: { type: "string", editable: false, nullable: false },
                    CropKey: { type: "number", editable: false, nullable: false },
                    AccType: { type: "number", editable: false, nullable: false },
                    AccTypeDesc: { type: "string", editable: false, nullable: false },
                    AccTypeAccCatCode: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    RcdType: { type: "number", editable: false, nullable: false },
                    RcdTypeDesc: { type: "string", editable: false, nullable: false },
                    AccSubTypeDesc: { type: "string", editable: false, nullable: false },
                    CreatedBy: { type: "number", editable: false, nullable: false },
                    CreatedDate: { type: "date", editable: false, nullable: false },
                    UpdatedBy: { type: "number", editable: false, nullable: false },
                    UpdatedDate: { type: "date", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "AccCat?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["coa", "facoa", "ccid", "faccid", "stoconfg"]
        },
        {
            Name: "fin",
            Cache: true,
            Sort: { field: "GLConfgKey", dir: "asc" },
            Model: {
                id: "GLConfgKey",
                fields: {
                    GLConfgKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    CompKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    IsAllowFutureDate: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.systemOdataUrl + "FinGLConfg?$format=json&$expand=finGLConfgOUDetails,finGLConfgOUAllocDetails",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["grniacc", "crniacc", "currinfo"]
        },
        {
            Name: "bgt",
            Cache: true,
            Sort: { field: "BGTConfgKey", dir: "asc" },
            Model: {
                id: "BGTConfgKey",
                fields: {
                    BGTConfgKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    OUKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    DefCalPatKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    EnableBgtVehRunDistr: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.systemOdataUrl + "BGTConfg?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "tax",
            Cache: true,
            Sort: { field: "TaxCode", dir: "asc" },
            Model: {
                id: "TaxKey",
                fields: {
                    TaxKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    TaxCode: { type: "string", editable: false, nullable: false },
                    TaxDesc: { type: "string", editable: false, nullable: false },
                    TaxCodeTaxDesc: { type: "string", editable: false, nullable: false },
                    TaxType: { type: "string", editable: false, nullable: false },
                    AccKey: { type: "number", editable: false, nullable: false },
                    AccNum: { type: "string", editable: false, nullable: false },
                    AccDesc: { type: "string", editable: false, nullable: false },
                    TaxAccDesc: { type: "string", editable: false, nullable: false },
                    DueDay: { type: "number", editable: false, nullable: false },
                    DueMth: { type: "number", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    IsEditable: { type: "boolean", editable: false, nullable: false },
                    IsClaimable: { type: "boolean", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Tax?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid"]
        },
        {
            Name: "terrain",
            Cache: true,
            Sort: { field: "TerrainCode", dir: "asc" },
            Model: {
                id: "TerrainKey",
                fields: {
                    TerrainKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    TerrainCode: { type: "string", editable: false, nullable: false },
                    TerrainDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    RcdType: { type: "number", editable: false, nullable: false },
                    RcdTypeDesc: { type: "string", editable: false, nullable: false },
                    Rate: { type: "decimal", editable: false, nullable: false },
                    CreatedBy: { type: "number", editable: false, nullable: false },
                    CreatedByCode: { type: "string", editable: false, nullable: false },
                    CreatedDate: { type: "date", editable: false, nullable: false },
                    UpdatedBy: { type: "number", editable: false, nullable: false },
                    UpdatedByCode: { type: "string", editable: false, nullable: false },
                    UpdatedDate: { type: "date", editable: false, nullable: false },
                    TerrainCodeTerrainDesc: { type: "string", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Terrain?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "soiltype",
            Cache: true,
            Sort: { field: "SoilTypeCode", dir: "asc" },
            Model: {
                id: "SoilTypeKey",
                fields: {
                    SoilTypeKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    SoilTypeCode: { type: "string", editable: false, nullable: false },
                    SoilTypeDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    RcdType: { type: "number", editable: false, nullable: false },
                    RcdTypeDesc: { type: "string", editable: false, nullable: false },
                    Rate: { type: "decimal", editable: false, nullable: false },
                    CreatedBy: { type: "number", editable: false, nullable: false },
                    CreatedByCode: { type: "string", editable: false, nullable: false },
                    CreatedDate: { type: "date", editable: false, nullable: false },
                    UpdatedBy: { type: "number", editable: false, nullable: false },
                    UpdatedByCode: { type: "string", editable: false, nullable: false },
                    UpdatedDate: { type: "date", editable: false, nullable: false },
                    SoilTypeCodeSoilTypeDesc: { type: "string", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "SoilType?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "uncularea",
            Cache: true,
            Sort: { field: "UnculAreaCode", dir: "asc" },
            Model: {
                id: "UnculAreaKey",
                fields: {
                    UnculAreaKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    UnculAreaCode: { type: "string", editable: false, nullable: false },
                    UnculAreaDesc: { type: "string", editable: false, nullable: false },
                    RcdType: { type: "number", editable: false, nullable: false },
                    CreatedBy: { type: "number", editable: false, nullable: false },
                    CreatedDate: { type: "date", editable: false, nullable: false },
                    UpdateBy: { type: "number", editable: false, nullable: false },
                    UpdatedDate: { type: "date", editable: false, nullable: false },
                    RcdTypeDesc: { type: "string", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "UnculArea?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "bgtprep",
            Cache: true,
            Sort: [{ field: "Yr", dir: "asc" }, { field: "Version", dir: "asc" }, { field: "BFPDesc", dir: "asc" }],
            Model: {
                id: "BFPKey",
                fields: {
                    BFPKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    BFPDesc: { type: "string", editable: false, nullable: false },
                    Yr: { type: "number", editable: false, nullable: false },
                    IsCompute: { type: "bool", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.budgetOdataUrl + "BgtFilePrep?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "facoa",
            Cache: true,
            Sort: { field: "AccNum", dir: "asc" },
            Model: {
                id: "AccKey",
                fields: {
                    AccKey: { type: "number", editable: false, nullable: false },
                    AccNum: { type: "string", editable: false, nullable: false },
                    AccDesc: { type: "string", editable: false, nullable: false },
                    AccNumAccDesc: { type: "string", editable: false, nullable: false },
                    AccCatKey: { type: "number", editable: false, nullable: false },
                    AccType: { type: "string", editable: false, nullable: false },
                    AnlysType: { type: "string", editable: false, nullable: false },
                    OperationTypeDesc: { type: "number", editable: false, nullable: true },
                    IsVFuelAcc: { type: "boolean", editable: false, nullable: false },
                    IsVLubAcc: { type: "boolean", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    AccMasOUKey: { type: "object", editable: false, nullable: false },
                    AccSubCatKey: { type: "number", editable: false, nullable: false },
                    CropKey: { type: "number", editable: false, nullable: false },
                    AccSubType: { type: "number", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "COA?isShowEverything=false&isShowFAonly=true&$format=json&$select=AccKey,AccNum,AccDesc,AccCatKey,AccCatSegKey,AccCatCode,AccCatDesc,AccType,AnlysType,AllowRevalue,OperationTypeKey,OperationTypeCode,OperationTypeDesc,IsVFuelAcc,IsVLubAcc,ClientKey,Active,CFTypeKey,CFTypeDesc,AccNumAccDesc,IsRequiredCCID,CostCenterType,UOMKey,UOMCode,UOMCodeUOMDesc,IsControlAccount,AccMasOUKey,CropKey,AccSubCatKey,AccSubCatDetKey,AccSubType",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["coa", "ccid", "faccid", "stoconfg"]
        },
        {
            Name: "faccid",
            Cache: true,
            Sort: { field: "CCIDCode", dir: "asc" },
            Model: {
                id: "CCIDKey",
                fields: {
                    CCIDCode: { type: "string", editable: false, nullable: false },
                    CCIDDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    OUList: { type: "object", editable: false, nullable: true },
                    AccList: { type: "object", editable: false, nullable: true },
                    AccCatList: { type: "object", editable: false, nullable: true },
                    CCTypeCodeList: { type: "object", editable: false, nullable: true },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "CCIDInfo?dummy=0&dummy1=1&$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid"]
        },
        {
            Name: "field",
            Cache: true,
            Sort: { field: "FieldCode", dir: "asc" },
            Model: {
                id: "FieldKey",
                fields: {
                    FieldKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    FieldCode: { type: "string", editable: false, nullable: false },
                    FieldDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "bool", editable: false, nullable: false },
                    OUKey: { type: "number", editable: false, nullable: false },
                    FieldCodeFieldDesc: { type: "string", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Field?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "stoconfg",
            Cache: true,
            Sort: { field: "STOConfgKey", dir: "asc" },
            Model: {
                id: "STOConfgKey",
                fields: {
                    STOConfgKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    ClientKey: { type: "number", editable: false, nullable: false },
                    OUKey: { type: "number", editable: false, nullable: false },
                    AllwSRWPO: { type: "boolean", editable: false, nullable: true },
                    AllwPOWPR: { type: "boolean", editable: false, nullable: true },
                    AllwCFAdj: { type: "boolean", editable: false, nullable: true },
                    EnforcePRPOQty: { type: "boolean", editable: false, nullable: true },
                    TrackSVByComp: { type: "boolean", editable: false, nullable: true },
                    SendNoti: { type: "boolean", editable: false, nullable: true },
                    EmpyDefAcc: { type: "number", editable: false, nullable: true },
                    EmpyDefTransOutAccKey: { type: "number", editable: false, nullable: true },
                    EmpyDefTransInAccKey: { type: "number", editable: false, nullable: true },
                    EmpyDefCCID: { type: "number", editable: false, nullable: true },
                    EmpyDefComp: { type: "string", editable: false, nullable: true },
                    GRNIAcc: { type: "number", editable: false, nullable: true },
                    STOConfgOUKey: { type: "object", editable: false, nullable: true },
                    EmpyDefAccNumAccDesc: { type: "string", editable: false, nullable: true },
                    EmpyDefTransOutAccNumAccDesc: { type: "string", editable: false, nullable: true },
                    EmpyDefTransInAccNumAccDesc: { type: "string", editable: false, nullable: true },
                    EmpyDefCompDesc: { type: "string", editable: false, nullable: true },
                    GRNIAccNumAccDesc: { type: "string", editable: false, nullable: true },
                    EnableAutoSI: { type: "boolean", editable: false, nullable: true },
                    COGSAccKey: { type: "number", editable: false, nullable: true },
                    COGSCCIDKey: { type: "number", editable: false, nullable: true },
                    COGSAccNumAccDesc: { type: "string", editable: false, nullable: true },
                    EmpyVendAccKey: { type: "number", editable: false, nullable: true },
                    EmpyVendCCIDKey: { type: "number", editable: false, nullable: true },
                    EmpyVendAccNumAccDesc: { type: "string", editable: false, nullable: true },
                    SundryAccKey: { type: "number", editable: false, nullable: true },
                    SundryCCIDKey: { type: "number", editable: false, nullable: true },
                    SundryAccNumAccDesc: { type: "string", editable: false, nullable: true },
                    ApplyUP: { type: "string", editable: false, nullable: true },
                    IsRequiredCCIDCOGS: { type: "boolean", editable: false, nullable: true },
                    IsRequiredCCIDEmpyVend: { type: "boolean", editable: false, nullable: true },
                    IsRequiredCCIDSundry: { type: "boolean", editable: false, nullable: true },
                    IsRequiredCCID: { type: "boolean", editable: false, nullable: true },
                    EnableUOMCV: { type: "boolean", editable: false, nullable: true },
                    RecoveryAccKey: { type: "number", editable: false, nullable: true },
                    RecoveryCCIDKey: { type: "number", editable: false, nullable: true },
                    RecoveryAccNumAccDesc: { type: "string", editable: false, nullable: true },
                    IsRequiredCCIDRec: { type: "boolean", editable: false, nullable: true },
                    EnableRec: { type: "boolean", editable: false, nullable: true },
                    EnableSRAmtOverPO: { type: "boolean", editable: false, nullable: true },
                    UnallwORQ: { type: "boolean", editable: false, nullable: true },
                    EnableJRAmtOverJO: { type: "boolean", editable: false, nullable: true },
                }
            },
            Http: {
                url: $rootScope.systemOdataUrl + "STOConfg?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "vegetype",
            Cache: true,
            Sort: { field: "VegeTypeCode", dir: "asc" },
            Model: {
                id: "VegeTypeKey",
                fields: {
                    VegeTypeKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    VegeTypeCode: { type: "string", editable: false, nullable: false },
                    VegeTypeDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    RcdType: { type: "number", editable: false, nullable: false },
                    RcdTypeDesc: { type: "string", editable: false, nullable: false },
                    CreatedBy: { type: "number", editable: false, nullable: false },
                    CreatedByCode: { type: "string", editable: false, nullable: false },
                    CreatedDate: { type: "date", editable: false, nullable: false },
                    UpdatedBy: { type: "number", editable: false, nullable: false },
                    UpdatedByCode: { type: "string", editable: false, nullable: false },
                    UpdatedDate: { type: "date", editable: false, nullable: false },
                    VegeTypeCodeVegeTypeDesc: { type: "string", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "VegeType?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid", "vege"]
        },
        {
            Name: "vege",
            Cache: true,
            Sort: { field: "VegeCode", dir: "asc" },
            Model: {
                id: "VegeKey",
                fields: {
                    VegeKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    VegeCode: { type: "string", editable: false, nullable: false },
                    VegeDesc: { type: "string", editable: false, nullable: false },
                    VegeTypeKey: { type: "number", editable: false, nullable: false },
                    VegeTypeDesc: { type: "string", editable: false, nullable: false },
                    UOMKey: { type: "number", editable: false, nullable: false },
                    UOMCode: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    VegeCodeVegeDesc: { type: "string", editable: false, nullable: false },
                    VegeOUKey: { type: "object", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Vege?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: ["ccid"]
        },
        {
            Name: "salesitem",
            Cache: true,
            Sort: { field: "SalesItemCode", dir: "asc" },
            Model: {
                id: "SalesItemKey",
                fields: {
                    SalesItemKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    SalesItemCode: { type: "string", editable: false, nullable: false },
                    SalesItemDesc: { type: "string", editable: false, nullable: false },
                    SalesItemCodeSalesItemDesc: { type: "string", editable: false, nullable: false },
                    UOMKey: { type: "number", editable: false, nullable: false },
                    UOMCode: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    CompKey: { type: "number", editable: false, nullable: false },
                    TypeCode: { type: "string", editable: false, nullable: false },
                    ProduceItemKey: { type: "number", editable: false, nullable: false },
                    ProduceGradeKey: { type: "number", editable: false, nullable: false },
                    IsMultipleProduce: { type: "boolean", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "SalesItem?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "clientnotification",
            Cache: false,
            Sort: { field: "CreatedDate", dir: "desc" },
            Model: {
                id: "NotificationKey",
                fields: {
                    NotificationKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    Title: { type: "string", editable: false, nullable: false },
                    Subtitle: { type: "string", editable: false, nullable: false },
                    Message: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    MenuUrl: { type: "string", editable: false, nullable: false },
                    JsControllerUrl: { type: "string", editable: false, nullable: false },
                    Sender: { type: "number", editable: false, nullable: false },
                    Receiver: { type: "number", editable: false, nullable: false },
                    Type: { type: "number", editable: false, nullable: false },
                    TypeDesc: { type: "string", editable: false, nullable: false },
                    Icon: { type: "string", editable: false, nullable: false },
                    CreatedBy: { type: "number", editable: false, nullable: false },
                    CreatedByCode: { type: "string", editable: false, nullable: false },
                    CreatedDate: { type: "date", editable: false, nullable: false },
                    UpdatedBy: { type: "number", editable: false, nullable: false },
                    UpdatedByCode: { type: "string", editable: false, nullable: false },
                    UpdatedDate: { type: "date", editable: false, nullable: false },
                }
            },
            Http: {
                url: $rootScope.adminOdataUrl + "ClientNotification?$expand=attaches&$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "wgitem",
            Cache: true,
            Sort: { field: "WgItemCode", dir: "asc" },
            Model: {
                id: "WgItemKey",
                fields: {
                    WgItemKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    WgItemCode: { type: "string", editable: false, nullable: false },
                    WgItemDesc: { type: "string", editable: false, nullable: false },
                    WgItemCodeDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false },
                    IsRevenueItem: { type: "boolean", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "WgItem?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "type",
            Cache: true,
            Sort: { field: "TypeKey", dir: "asc" },
            Model: {
                id: "TypeKey",
                fields: {
                    TypeKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    TypeCode: { type: "string", editable: false, nullable: false },
                    TypeDesc: { type: "string", editable: false, nullable: false },
                    TypeCodeTypeDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "Type?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "typeID",
            Cache: true,
            Sort: { field: "TypeIDKey", dir: "asc" },
            Model: {
                id: "TypeIDKey",
                fields: {
                    TypeIDKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    TypeIDCode: { type: "string", editable: false, nullable: false },
                    TypeIDDesc: { type: "string", editable: false, nullable: false },
                    TypeIDCodeDesc: { type: "string", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "TypeID?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "class",
            Cache: true,
            Sort: { field: "ClassCode", dir: "asc" },
            Model: {
                id: "ClassCodeKey",
                fields: {
                    ClassCodeKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    ClassCode: { type: "string", editable: false, nullable: false },
                    ClassDesc: { type: "string", editable: false, nullable: false },
                    ClassCodeDesc: { type: "string", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "ClassCode?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        },
        {
            Name: "blocktask",
            Cache: true,
            Sort: { field: "TaskCode", dir: "asc" },
            Model: {
                id: "BlockTaskKey",
                fields: {
                    BlockTaskKey: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                    TaskCode: { type: "string", editable: false, nullable: false },
                    BlockKey: { type: "number", editable: false, nullable: false },
                    OUKey: { type: "number", editable: false, nullable: false },
                    Active: { type: "boolean", editable: false, nullable: false }
                }
            },
            Http: {
                url: $rootScope.masterOdataUrl + "BlockTask?$format=json",
                method: 'GET',
                jsonp: false,
                dataType: "json"
            },
            Collateral: []
        }
    ];

    //generate unique ID to represent User for storing cache
    let _generateSessionID = function ()
    {
        if (typeof authService?.authentication?.clientID === "string"
            && typeof authService?.authentication?.userID === "string")
        {
            return authService.authentication.clientID.replace(/[^0-9a-z]/gi, "").trim()
                + "_"
                + authService?.authentication.userID.replace(/[^0-9a-z]/gi, "").trim();
        }

        return "";
    };

    //generate simple checksum to ensure data integrity
    let _generateSimpleChecksum = function (s)
    {
        let chk = 0x12345678;
        let len = s.length;
        for (var i = 0; i < len; i++)
            chk += (s.charCodeAt(i) * (i + 1));

        return (chk & 0xffffffff).toString(16);
    };

    //generate random ID in order to generate GUID
    let _generateRandomID = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);

    //generate GUID
    let _generateGUID = () => _generateRandomID() + _generateRandomID() + '-' + _generateRandomID() + '-' + _generateRandomID() + '-' + _generateRandomID() + '-' + _generateRandomID() + _generateRandomID() + _generateRandomID();

    //hardcoded list of client blacklisted from cache
    let _isClientBlacklisted = function ()
    {
        if (typeof authService?.authentication?.clientID === "string"
            && typeof authService?.authentication?.userID === "string")
        {
            return [
                //PIPIT
                //"A40AD5C9-A8CD-4801-8CFB-7D03088A6B8F",
                //KLR
                //"E84A6777-02E9-437A-8629-50289D28E4C0",
                //ASAM
                //"A05DDF1B-EF6A-4C5B-B4B6-C554EF26FE77",
                //LFK
                //"D77D174C-588E-4B9C-8AE5-A31990FA662E"
            ].includes(authService.authentication.clientID.toUpperCase());
        }

        return false;
    }

    //initialize logging db
    let _openPerfDB = function ()
    {
        let Perfrequest = null;

        return new Promise(function (resolve, reject)
        {
            if (_IDBInfo.enableIndexedDB)
            {
                //no longer check for persistence, chrome removed navigator.storage

                Perfrequest = window.indexedDB.open("PerformanceCollection", _IDBInfo.PerfIndexedDBVer);

                Perfrequest.onupgradeneeded = function (event)
                {
                    let thisPerfDB = event.target.result;

                    if (!thisPerfDB.objectStoreNames.contains(_IDBInfo.PerfDataTableName))
                    {
                        thisPerfDB.createObjectStore(_IDBInfo.PerfDataTableName, { keyPath: ["type", "ID"] });
                    }
                    else
                    {
                        thisPerfDB.deleteObjectStore(_IDBInfo.PerfDataTableName);
                        thisPerfDB.createObjectStore(_IDBInfo.PerfDataTableName, { keyPath: ["type", "ID"] });
                    }
                };

                Perfrequest.onsuccess = function (event)
                {
                    _IDBInfo.enableIndexedDB = true;
                    resolve(event.target.result);
                };

                Perfrequest.onerror = function (event)
                {
                    reject();
                    console.log(event.target.errorCode);
                };

                Perfrequest.onblocked = function (event)
                {
                    reject();
                    console.log(event.target.errorCode);
                };
            }
            else
            {
                _IDBInfo.enableIndexedDB = false;
                reject();
            }
        });
    };

    //initialize cache db
    let _openDB = function ()
    {
        let request = null;

        return new Promise(function (resolve, reject)
        {
            if (_IDBInfo.enableIndexedDB)
            {
                //no longer check for persistence, chrome removed navigator.storage

                request = window.indexedDB.open("DataSourceCollection", _IDBInfo.IndexedDBVer);

                request.onupgradeneeded = function (event)
                {
                    let thisDB = event.target.result;

                    if (!thisDB.objectStoreNames.contains(_IDBInfo.DataTableName))
                    {
                        thisDB.createObjectStore(_IDBInfo.DataTableName, { keyPath: ["type", "ID"] });
                    }
                    else
                    {
                        thisDB.deleteObjectStore(_IDBInfo.DataTableName);
                        thisDB.createObjectStore(_IDBInfo.DataTableName, { keyPath: ["type", "ID"] });
                    }
                };

                request.onsuccess = function (event)
                {
                    _IDBInfo.enableIndexedDB = true;
                    resolve(event.target.result);
                };

                request.onerror = function (event)
                {
                    reject();
                    console.log(event.target.errorCode);
                };

                request.onblocked = function (event)
                {
                    reject();
                    console.log(event.target.errorCode);
                };
            }
            else
            {
                _IDBInfo.enableIndexedDB = false;
                reject();
            }
        });
    };

    //collect logging entries
    let _logGeneralJsError = function (message, source, lineno, colno, error)
    {
        if (message !== "ResizeObserver loop limit exceeded")
        {
            _entrytoPerfDB({
                type: "jsError",
                ID: _generateGUID().toString(),
                log_StartTime: new Date(),
                log_EndTime: new Date(),
                error_Source: source,
                error_LineNo: lineno,
                error_ColNo: colno,
                error_Name: (error === null || typeof error === "undefined") ? "framework error" : error.name,
                error_FullMsg: message,
                error_Msg: (error === null || typeof error === "undefined") ? "framework error" : error.message,
                error_Stk: (error === null || typeof error === "undefined") ? "framework error" : error.stack
            })
        }
    };

    //post logging entries
    let _postPerfDBLog = function ()
    {
        if ($rootScope.getConnectionState("main") === $.signalR.connectionState.connected)
        {
            if (_IDBInfo.enableIndexedDB === true)
                _openPerfDB().then(function (db)
                {
                    //call only if connected
                    let CurrentReq = db.transaction([_IDBInfo.PerfDataTableName], "readwrite").objectStore(_IDBInfo.PerfDataTableName).getAll();

                    CurrentReq.onsuccess = function (e)
                    {
                        let removed = [];
                        let len = e.target.result.length;
                        for (var i = 0; i < len; i++)
                        {
                            $rootScope.postPerfDBLog(JSON.stringify({
                                StartTime: e.target.result[i].log_StartTime,
                                EndTime: e.target.result[i].log_EndTime,
                                UserKey: (authService?.authentication?.userKey) ?? -1,
                                UserID: (authService?.authentication?.userID) ?? "",
                                Type: e.target.result[i].type,
                                FormName: e.target.result[i].error_Source,
                                MethodName: "Line No:" + e.target.result[i].error_LineNo.toString() + ", Column No:" + e.target.result[i].error_ColNo.toString(),
                                Parameter: "",
                                ErrMsg: e.target.result[i].error_FullMsg,
                                ErrMsg_Additional: e.target.result[i].error_Stk
                            }));
                            removed.push([e.target.result[i].type, e.target.result[i].ID]);
                        }

                        len = removed.length;
                        for (var j = 0; j < len; j++)
                        {
                            //dont delete first, need data to dev
                            db.transaction([_IDBInfo.PerfDataTableName], "readwrite").objectStore(_IDBInfo.PerfDataTableName).delete(removed[j]);
                        }
                    };

                    CurrentReq.onerror = function (e)
                    {
                        //failed to get. no hope. give up. =D
                    };
                });
        }
    };

    //insert into logging db
    let _entrytoPerfDB = function (logValue)
    {
        if (_IDBInfo.enableIndexedDB === true)
            _openPerfDB().then(function (db)
            {
                let CurrentReq = db.transaction([_IDBInfo.PerfDataTableName], "readwrite").objectStore(_IDBInfo.PerfDataTableName).put(logValue);

                CurrentReq.onsuccess = function (e)
                {
                    //well, what do you want?
                };

                CurrentReq.onerror = function (e)
                {
                    console.log(e);
                };
            });
    };

    //insert into cache db
    let _entrytoDB = function (cacheValue, cacheName)
    {
        if (_IDBInfo.enableIndexedDB === true && typeof cacheValue == "string" && typeof cacheName == "string")
            _openDB().then(function (db)
            {
                let CurrentReq = db.transaction([_IDBInfo.DataTableName], "readwrite").objectStore(_IDBInfo.DataTableName).put({
                    type: cacheName,
                    dataString: cacheValue,
                    created: new Date(),
                    checksum: _generateSimpleChecksum(cacheValue),
                    ID: _generateSessionID()
                });

                CurrentReq.onsuccess = function (e)
                {
                    //well, what do you want?
                };

                CurrentReq.onerror = function (e)
                {
                    console.log(e);
                };
            });
    };

    //parse string to decimal
    let _parseStringToDecimal = function (o)
    {
        if (typeof o !== "undefined" && o !== null && o !== "")
        {
            Object.keys(o).forEach(k =>
            {
                let _type = typeof o[k];
                if (_type === 'object')
                {
                    return _parseStringToDecimal(o[k]);
                }
                else if (_type === "string"
                    && o[k] !== ""
                    && (o[k].indexOf('.') > 0 || k === "OrigDrAmt" || k === "OrigCrAmt"))
                {
                    let _val = +o[k];
                    if (!isNaN(_val) && isFinite(_val))
                    {
                        o[k] = _val;
                    }
                }
            });
        }

        return o;
    };

    /*
        Cache update flow
        --------------------------------------
        User A update setup (ie Contact Setup)
                        ↓
        front end : cacheService => _broadcastUpdateSignal
                        ↓
        front end : signalRService => $rootScope.propagateSignal
                        ↓
        backend   : ChatHub => BroadcastUpdateSignal   →  (User B receive update)   →   backend   : ChatHub => receiveUpdateSignal
                        ↓                                                                               ↓
        front end : cacheService => _receiveUpdateSignal                                front end : cacheService => _receiveUpdateSignal
                        ↓                                                                               ↓
        updated User A cache                                                            updated User B cache
    */

    //broadcast update signal to update cache
    let _broadcastUpdateSignal = function (cacheName)
    {
        let updateSignal = new Promise(function (resolve, reject)
        {
            let type =
                (typeof cacheName == "string") && (cacheName.toLowerCase().trim() != "") && _DataSourceCollection.some(x => x.Name == cacheName.toLowerCase().trim())
                    ? cacheName.toLowerCase().trim()
                    : "";

            $rootScope.propagateSignal(type).then(
                (result) => resolve(typeof result === "string" ? result.split(",") : [""]),
                () => resolve([""]));
        });

        return new Promise(function (resolve, reject)
        {
            updateSignal.then(
                (signal) => _receiveUpdateSignal(signal).then(() => resolve(), () => resolve()),
                () => resolve());
        });
    }

    //receive update signal to update cache
    let _receiveUpdateSignal = function (signal)
    {
        try { console.log("%cReceived update broadcast : Updating " + (signal.some(type => type == "") ? "all" : JSON.stringify(signal)) + " !", 'background:red;color:#fff'); } catch { }

        let CurrentID = _generateSessionID();

        return new Promise(function (resolve, reject)
        {
            if (Array.isArray(signal) && _IDBInfo.enableIndexedDB === true)
            {
                _openDB().then((db) =>
                {
                    Promise.allSettled(
                        (signal.some(type => type == "")
                            //blank signal received, clear everything
                            ? _DataSourceCollection.map(ds => ds.Name)
                            //find collateral to update along with signal
                            : [...new Set(_DataSourceCollection.filter(ds => signal.includes(ds.Name)).flatMap(ds => ds.Collateral).concat(signal))]).map(item =>
                            {
                                return new Promise((_resolve, _reject) =>
                                {
                                    let CurrentReq = db.transaction([_IDBInfo.DataTableName], "readwrite").objectStore(_IDBInfo.DataTableName).delete([item, CurrentID]);
                                    CurrentReq.onsuccess = () => _resolve();
                                    CurrentReq.onerror = () => _resolve();
                                });
                            })).then(() => resolve(), () => resolve());
                }, () => resolve());
            }
            else
            {
                resolve();
            }
        });
    };

    //get data for cached datasource
    let _getData = function (cacheName)
    {
        let CurrentID = _generateSessionID();

        return new Promise((resolve, reject) =>
        {
            if (typeof cacheName == "string")
            {
                if (cacheName == "allcoa")
                {
                    Promise.all([_getData("coa"), _getData("facoa")]).then((data) =>
                    {
                        resolve(_.cloneDeep(data[0].concat(data[1])));
                    }, () =>
                    {
                        console.log("Failed to read " + cacheName);
                        reject();
                    });
                }
                else if (cacheName == "allccid")
                {
                    Promise.all([_getData("ccid"), _getData("faccid")]).then((data) =>
                    {
                        resolve(_.cloneDeep(data[0].concat(data[1])));
                    }, () =>
                    {
                        console.log("Failed to read " + cacheName);
                        reject();
                    });
                }
                else if (_DataSourceCollection.some(x => x.Name == cacheName))
                {
                    let _DataSource = _DataSourceCollection.find(x => x.Name == cacheName);

                    if (_IDBInfo.enableIndexedDB === true && _DataSource.Cache === true && _isClientBlacklisted() == false)
                    {
                        _openDB().then((db) =>
                        {
                            let CurrentReq = db.transaction([_IDBInfo.DataTableName], "readwrite").objectStore(_IDBInfo.DataTableName).get([cacheName, CurrentID]);

                            CurrentReq.onsuccess = function (e)
                            {
                                if ((typeof e?.target?.result?.dataString != "undefined") && _generateSimpleChecksum(e.target.result.dataString) == e.target.result.checksum
                                    && e.target.result.ID == CurrentID)
                                {
                                    resolve(JSON.parse(e.target.result.dataString));
                                }
                                else
                                {
                                    $http(_DataSource.Http).then((data) =>
                                    {
                                        let _data = (typeof data?.data?.value != "undefined") ? data.data.value : ((typeof data?.data != "undefined") ? data.data : void 0);
                                        _data = ((typeof _data != "undefined") && _data != null) ? _parseStringToDecimal(_data) : [];
                                        _entrytoDB(JSON.stringify(_data), cacheName);
                                        resolve(_data);
                                    }, () =>
                                    {
                                        reject();
                                    });
                                }
                            };

                            CurrentReq.onerror = function (e)
                            {
                                $http(_DataSource.Http).then((data) =>
                                {
                                    let _data = (typeof data?.data?.value != "undefined") ? data.data.value : ((typeof data?.data != "undefined") ? data.data : void 0);
                                    _data = ((typeof _data != "undefined") && _data != null) ? _parseStringToDecimal(_data) : [];
                                    _entrytoDB(JSON.stringify(_data), cacheName);
                                    resolve(_data);
                                }, () =>
                                {
                                    reject();
                                });
                            };
                        }, () =>
                        {
                            $http(_DataSource.Http).then((data) =>
                            {
                                let _data = (typeof data?.data?.value != "undefined") ? data.data.value : ((typeof data?.data != "undefined") ? data.data : void 0);
                                resolve(((typeof _data != "undefined") && _data != null) ? _parseStringToDecimal(_data) : []);
                            }, () =>
                            {
                                reject();
                            });
                        });
                    }
                    else
                    {
                        $http(_DataSource.Http).then((data) =>
                        {
                            let _data = (typeof data?.data?.value != "undefined") ? data.data.value : ((typeof data?.data != "undefined") ? data.data : void 0);
                            resolve(((typeof _data != "undefined") && _data != null) ? _parseStringToDecimal(_data) : []);
                        }, () =>
                        {
                            reject();
                        });
                    }
                }
                else
                {
                    console.log("Invalid cache name detected : ");
                    console.log(cacheName);
                    resolve([]);
                }
            }
            else
            {
                console.log("Invalid cache name detected : ");
                console.log(cacheName);
                resolve([]);
            }
        });
    }

    //task queue to make sure sequential read to avoid overwhelmed server
    function createTaskQueue()
    {
        var queue = [];

        function enqueue(fn, args)
        {
            validate(fn, args);
            var shouldRun = queue.length === 0; var task = createTask(fn, args);
            queue.push(task);
            if (shouldRun)
                run();
            return task.promise;
        }

        function validate(fn, args)
        {
            if (typeof fn !== 'function')
                throw new Error('Please provide a function to enqueue.');

            if (args && !Array.isArray(args))
                throw new Error('Please provide task arguments as an array to enqueue.');
        }

        function run()
        {
            var task = queue[0];
            Promise.resolve(task.fn.apply(undefined, task.args || [])).then(task.resolve).catch(task.reject).then(handleResult);
        }

        function handleResult()
        {
            queue.shift();
            if (queue.length === 0)
                return;
            run();
        }

        return { enqueue: enqueue };
    }

    function createTask(fn, args)
    {
        var resolve, reject;
        var promise = new Promise(function (res, rej) { resolve = res; reject = rej; });
        return { fn: fn, args: args, resolve: resolve, reject: reject, promise: promise };
    }

    //limited to 2 queues, (slow and fast queue)
    const taskQueueA = createTaskQueue();
    const taskQueueB = createTaskQueue();

    //get cached datasource
    let _getCachedDataSource = function (cacheName, sorting, filter)
    {
        if (typeof cacheName === "string"
            && (_DataSourceCollection.some(x => x.Name == cacheName) || cacheName == "allcoa" || cacheName == "allccid"))
        {
            let _DataSource = _DataSourceCollection.find(item =>
            {
                return (cacheName == "allcoa" && item.Name == "coa")
                    || (cacheName == "allccid" && item.Name == "ccid")
                    || (cacheName == item.Name);
            });

            return kendo.data.DataSource.create({
                type: "odata",
                schema:
                {
                    data: (data) => data,
                    total: (data) => data.length,
                    model: _.cloneDeep(_DataSource.Model)
                },
                pageSize: $rootScope.comboBoxPageSize,
                transport:
                {
                    read: function (options)
                    {
                        ((["empy", "itemmas", "contact", "block", "coa", "ccid", "facoa", "faccid", "allcoa", "allccid"].includes(cacheName))
                            ? taskQueueA.enqueue(_getData, [cacheName])
                            : taskQueueB.enqueue(_getData, [cacheName])).then(function (data)
                            {
                                if (typeof data.sortBy === "function" && (typeof sorting !== "undefined" || typeof _DataSource.Sort !== "undefined"))
                                {
                                    let currentSort = typeof sorting !== "undefined" ? _.cloneDeep(sorting) : _.cloneDeep(_DataSource.Sort);

                                    if (typeof currentSort.length === "undefined")
                                    {
                                        options.success(currentSort.dir === "desc" ? data.sortBy("-" + currentSort.field) : data.sortBy(currentSort.field));
                                    }
                                    else
                                    {
                                        let sortArray = currentSort.map(x => x.dir == "desc" ? ("-" + x.field) : x.field);

                                        options.success(sortArray.length === 0 ? data : data.sortBy(...sortArray));
                                    }
                                }
                                else
                                {
                                    options.success(data);
                                }
                            }, function ()
                            {
                                options.error("failed to read");
                            });
                    }
                },
                sort: typeof sorting !== "undefined" ? sorting : (typeof _DataSource.Sort !== "undefined" ? _.cloneDeep(_DataSource.Sort) : void 0),
                filter: typeof filter !== "undefined" ? filter : void 0
            });
        }
        else
        {
            console.log("Invalid cache name detected : ");
            console.log(cacheName);
            return new kendo.data.DataSource();
        }
    }

    //get ClientKey of current session
    let _getSessionClientKey = function ()
    {
        if (typeof authService?.authentication?.clientID === "string"
            && typeof authService?.authentication?.userID === "string")
        {
            return +(authService.authentication.ClientKey);
        }

        return -1;
    }

    //evict outdated cache
    let _evictOutdatedCache = function ()
    {
        let CurrentID = _generateSessionID();

        return new Promise(function (resolve, reject)
        {
            if (_IDBInfo.enableIndexedDB === true)
            {
                _openDB().then((db) =>
                {
                    let CurrentReq = db.transaction([_IDBInfo.DataTableName], "readwrite").objectStore(_IDBInfo.DataTableName).getAll();

                    CurrentReq.onsuccess = function (e)
                    {
                        $http({
                            url: $rootScope.httpName + $rootScope.quartoDNS + "/api/VerifyDSCollection?",
                            method: 'POST',
                            data: e.target.result.filter(row => row.ID == CurrentID).map(item =>
                            {
                                return {
                                    Date: item.created,
                                    Type: item.type
                                };
                            }),
                            headers: { 'Content-Type': 'application/json' }
                        }).success(function (data)
                        {
                            Promise.allSettled(
                                JSON.parse(data).split(",")
                                    .map(item => db.transaction([_IDBInfo.DataTableName], "readwrite").objectStore(_IDBInfo.DataTableName).delete([item, CurrentID]))
                            ).then(() => resolve());
                        }).error(function ()
                        {
                            reject();
                        });
                    };

                    CurrentReq.onerror = function (e)
                    {
                        reject();
                    };
                }, () =>
                {
                    reject();
                })
            }
            else
            {
                reject();
            }
        });
    }

    //evict selected cache
    let _evictCache = function (cacheName)
    {
        let CurrentID = _generateSessionID();

        return new Promise(function (resolve, reject)
        {
            if (_IDBInfo.enableIndexedDB === true)
            {
                _openDB().then((db) =>
                {
                    if ((typeof cacheName != "string") || (typeof cacheName == "string" && cacheName == ""))
                    {
                        //clear everything
                        Promise.allSettled(
                            _DataSourceCollection
                                .map(item => new Promise((_resolve, _reject) =>
                                {
                                    let CurrentReq = db.transaction([_IDBInfo.DataTableName], "readwrite").objectStore(_IDBInfo.DataTableName).delete([item.Name, CurrentID]);
                                    CurrentReq.onsuccess = () => _resolve();
                                    CurrentReq.onerror = () => _resolve();
                                }))
                        ).then(() => resolve());
                    }
                    else if (typeof cacheName == "string" && cacheName == "allcoa")
                    {
                        Promise.all([_evictCache("coa"), _evictCache("facoa")]).then(() => resolve(), () => resolve());
                    }
                    else if (typeof cacheName == "string" && cacheName == "allccid")
                    {
                        Promise.all([_evictCache("ccid"), _evictCache("faccid")]).then(() => resolve(), () => resolve());
                    }
                    else if (typeof cacheName == "string" && _DataSourceCollection.some(x => x.Name == cacheName))
                    {
                        //clear self
                        let CurrentReq = db.transaction([_IDBInfo.DataTableName], "readwrite").objectStore(_IDBInfo.DataTableName).delete([cacheName, CurrentID]);
                        CurrentReq.onsuccess = () => resolve();
                        CurrentReq.onerror = () => resolve();
                    }
                    else
                    {
                        reject();
                    }
                }, () =>
                {
                    reject();
                })
            }
            else
            {
                reject();
            }
        });
    }

    //get country version
    let _getCtryVersion = function ()
    {
        let CurrentID = _generateSessionID();

        return new Promise(function (resolve, reject)
        {
            $http({
                url: $rootScope.httpName + $rootScope.quartoDNS + '/api/WebConfig/GetWebConfig',
                method: "GET",
            }).success(function (data)
            {
                //should assign this in display service...
                $rootScope.CtryVersion = data.contains("M") ? "M" : data.contains("I") ? "I" : data;
                $rootScope.IsCtryVersionMalaysia = $rootScope.CtryVersion === "M";
                $rootScope.IsCtryVersionIndonesia = $rootScope.CtryVersion === "I";

                resolve($rootScope.CtryVersion);
            }).error(function ()
            {
                reject();
            });
        });
    };

    //get language pack (label)
    let _getLanguagePack = function (isReadCache)
    {
        let CurrentID = _generateSessionID();
        let CacheName = "languagepack";

        if (typeof isReadCache === "boolean" && isReadCache === true)
        {
            return new Promise(function (resolve, reject)
            {
                if (_IDBInfo.enableIndexedDB === true)
                {
                    _openDB().then((db) =>
                    {
                        let CurrentReq = db.transaction([_IDBInfo.DataTableName], "readwrite").objectStore(_IDBInfo.DataTableName).get([CacheName, CurrentID]);

                        CurrentReq.onsuccess = function (e)
                        {
                            if ((typeof e?.target?.result?.dataString != "undefined") && _generateSimpleChecksum(e.target.result.dataString) == e.target.result.checksum
                                && e.target.result.ID == CurrentID)
                            {
                                resolve(JSON.parse(e.target.result.dataString));
                            }
                            else
                            {
                                _getLanguagePack(false).then((result) =>
                                {
                                    resolve(result);
                                }, () =>
                                {
                                    reject()
                                });
                            }
                        };

                        CurrentReq.onerror = function (e)
                        {
                            _getLanguagePack(false).then((result) =>
                            {
                                resolve(result);
                            }, () =>
                            {
                                reject()
                            });
                        };
                    }, () =>
                    {
                        _getLanguagePack(false).then((result) =>
                        {
                            resolve(result);
                        }, () =>
                        {
                            reject()
                        });
                    });
                }
                else
                {
                    _getLanguagePack(false).then((result) =>
                    {
                        resolve(result);
                    }, () =>
                    {
                        reject()
                    });
                }
            });
        }
        else
        {
            return new Promise(function (resolve, reject)
            {
                $http.get($rootScope["masterWebApiUrl"] + 'languagepack').then(function (result)
                {
                    if (typeof result?.data != "undefined")
                    {
                        _entrytoDB(JSON.stringify(result.data), CacheName);
                        resolve(result.data);
                    }
                    else
                    {
                        reject();
                    }
                }, () =>
                {
                    reject();
                });
            });
        }
    }

    //get message
    let _getMessage = function (isReadCache)
    {
        let CurrentID = _generateSessionID();
        let CacheName = "message";

        if (typeof isReadCache === "boolean" && isReadCache === true)
        {
            return new Promise(function (resolve, reject)
            {
                if (_IDBInfo.enableIndexedDB === true)
                {
                    _openDB().then((db) =>
                    {
                        let CurrentReq = db.transaction([_IDBInfo.DataTableName], "readwrite").objectStore(_IDBInfo.DataTableName).get([CacheName, CurrentID]);

                        CurrentReq.onsuccess = function (e)
                        {
                            if ((typeof e?.target?.result?.dataString != "undefined") && _generateSimpleChecksum(e.target.result.dataString) == e.target.result.checksum
                                && e.target.result.ID == CurrentID)
                            {
                                resolve(JSON.parse(e.target.result.dataString));
                            }
                            else
                            {
                                _getMessage(false).then((result) =>
                                {
                                    resolve(result);
                                }, () =>
                                {
                                    reject()
                                });
                            }
                        };

                        CurrentReq.onerror = function (e)
                        {
                            _getMessage(false).then((result) =>
                            {
                                resolve(result);
                            }, () =>
                            {
                                reject()
                            });
                        };
                    }, () =>
                    {
                        _getMessage(false).then((result) =>
                        {
                            resolve(result);
                        }, () =>
                        {
                            reject()
                        });
                    });
                }
                else
                {
                    _getMessage(false).then((result) =>
                    {
                        resolve(result);
                    }, () =>
                    {
                        reject()
                    });
                }
            });
        }
        else
        {
            return new Promise(function (resolve, reject)
            {
                $http.get($rootScope.masterWebApiUrl + 'messagepack').then(function (result)
                {
                    if (typeof result?.data != "undefined")
                    {
                        _entrytoDB(JSON.stringify(result.data), CacheName);
                        resolve(result.data);
                    }
                    else
                    {
                        reject();
                    }
                }, () =>
                {
                    reject();
                });
            });
        }
    }

    //get client menu
    let _getClientMenu = function (isReadCache)
    {
        let CurrentID = _generateSessionID();
        let CacheName = "clientmenu";

        if (typeof isReadCache === "boolean" && isReadCache === true)
        {
            return new Promise(function (resolve, reject)
            {
                if (_IDBInfo.enableIndexedDB === true)
                {
                    _openDB().then((db) =>
                    {
                        let CurrentReq = db.transaction([_IDBInfo.DataTableName], "readwrite").objectStore(_IDBInfo.DataTableName).get([CacheName, CurrentID]);

                        CurrentReq.onsuccess = function (e)
                        {
                            if ((typeof e?.target?.result?.dataString != "undefined") && _generateSimpleChecksum(e.target.result.dataString) == e.target.result.checksum
                                && e.target.result.ID == CurrentID)
                            {
                                resolve(JSON.parse(e.target.result.dataString));
                            }
                            else
                            {
                                _getClientMenu(false).then((result) =>
                                {
                                    resolve(result);
                                }, () =>
                                {
                                    reject()
                                });
                            }
                        };

                        CurrentReq.onerror = function (e)
                        {
                            _getClientMenu(false).then((result) =>
                            {
                                resolve(result);
                            }, () =>
                            {
                                reject()
                            });
                        };
                    }, () =>
                    {
                        _getClientMenu(false).then((result) =>
                        {
                            resolve(result);
                        }, () =>
                        {
                            reject()
                        });
                    });
                }
                else
                {
                    _getClientMenu(false).then((result) =>
                    {
                        resolve(result);
                    }, () =>
                    {
                        reject()
                    });
                }
            });
        }
        else
        {
            return new Promise(function (resolve, reject)
            {
                $http.get($rootScope["masterOdataUrl"] + 'CRegisteredClientMenuByUser').then(function (result)
                {
                    if (typeof result?.data?.value != "undefined")
                    {
                        _entrytoDB(JSON.stringify(result.data.value), CacheName);
                        resolve(result.data.value);
                    }
                    else
                    {
                        reject();
                    }
                }, () =>
                {
                    reject();
                });
            });
        }
    }

    //get grid
    let _getGrid = function (isReadCache)
    {
        let CurrentID = _generateSessionID();
        let CacheName = "grid";

        if (typeof isReadCache === "boolean" && isReadCache === true)
        {
            return new Promise(function (resolve, reject)
            {
                if (_IDBInfo.enableIndexedDB === true)
                {
                    _openDB().then((db) =>
                    {
                        let CurrentReq = db.transaction([_IDBInfo.DataTableName], "readwrite").objectStore(_IDBInfo.DataTableName).get([CacheName, CurrentID]);

                        CurrentReq.onsuccess = function (e)
                        {
                            if ((typeof e?.target?.result?.dataString != "undefined") && _generateSimpleChecksum(e.target.result.dataString) == e.target.result.checksum
                                && e.target.result.ID == CurrentID)
                            {
                                resolve(JSON.parse(e.target.result.dataString));
                            }
                            else
                            {
                                _getGrid(false).then((result) =>
                                {
                                    resolve(result);
                                }, () =>
                                {
                                    reject()
                                });
                            }
                        };

                        CurrentReq.onerror = function (e)
                        {
                            _getGrid(false).then((result) =>
                            {
                                resolve(result);
                            }, () =>
                            {
                                reject()
                            });
                        };
                    }, () =>
                    {
                        _getGrid(false).then((result) =>
                        {
                            resolve(result);
                        }, () =>
                        {
                            reject()
                        });
                    });
                }
                else
                {
                    _getGrid(false).then((result) =>
                    {
                        resolve(result);
                    }, () =>
                    {
                        reject()
                    });
                }
            });
        }
        else
        {
            return new Promise(function (resolve, reject)
            {
                $http.get($rootScope["masterOdataUrl"] + "CRegisteredGrid?&$expand=CmplsryDetails,GridDetails").then(function (result)
                {
                    if (typeof result?.data != "undefined")
                    {
                        _entrytoDB(JSON.stringify(result.data), CacheName);
                        resolve(result.data);
                    }
                    else
                    {
                        reject();
                    }
                }, () =>
                {
                    reject();
                });
            });
        }
    }

    //consolidate language pack, message, client menu, grid, country version
    let _getUIInformation = function ()
    {
        return new Promise(function (resolve, reject)
        {
            _evictOutdatedCache().then(() =>
            {
                Promise.all([
                    _getCtryVersion(),
                    _getLanguagePack(true),
                    _getMessage(true),
                    _getClientMenu(true),
                    _getGrid(true)
                ]).then((result) =>
                {
                    resolve(result);
                }, () =>
                {
                    reject();
                });
            }, () =>
            {
                Promise.all([
                    _getCtryVersion(),
                    _getLanguagePack(false),
                    _getMessage(false),
                    _getClientMenu(false),
                    _getGrid(false)
                ]).then((result) =>
                {
                    resolve(result);
                }, () =>
                {
                    reject();
                });
            });
        });
    }

    //custom filter operator cloned from control service
    let _OpContains = function (item, value)
    {
        let found = false;

        if (typeof item !== "undefined")
        {
            let itemList = [];

            if (typeof item === "string")
            {
                itemList = item.split(",");
            }
            else if (typeof item === "object")
            {
                itemList = item;
            }

            let itemLength = itemList.length;
            for (var i = 0; i < itemLength; i++)
            {
                if (typeof itemList[i] !== "undefined")
                {
                    if (Array.isArray(value))
                    {
                        if (value.includes(itemList[i]))
                        {
                            found = true;
                            break;
                        }
                    }
                    else if (typeof value == "string" || typeof value == "number")
                    {
                        if (itemList[i] == value)
                        {
                            found = true;
                            break;
                        }
                    }
                }
            }
        }

        return found;
    };

    //custom kendo function
    let _initializeCustomKendoFunction = (function _initializeCustomKendoFunction()
    {
        if ((typeof kendo !== "undefined") && (typeof kendo._isExtended === "undefined"))
        {
            kendo._isExtended = true;

            //custom function to redraw only one row
            kendo.ui.Grid.prototype.redrawRow = function (uid)
            {
                let grid = this;

                let colGroup = $('[data-uid="' + uid + '"]');

                if (colGroup.length == 1)
                {
                    //no frozen column
                    let dataItem = grid.dataItem(colGroup[0]);
                    let rowChildren = $(colGroup[0]).children('td[role="gridcell"]');

                    for (var i = 0; i < grid.columns.length; i++)
                    {
                        var column = grid.columns[i];
                        var template = column.template;
                        var cell = rowChildren.eq(i);

                        if (template !== undefined)
                        {
                            //compile with kendo
                            var kendoTemplate = kendo.template(template);

                            if (template.contains("'checkbox'"))
                            {
                                //render the cell, special handle for angular event like ng-click
                                cell.html($compile(kendoTemplate(dataItem))(cell.scope().$parent));
                            }
                            else
                            {
                                //render the cell
                                cell.html(kendoTemplate(dataItem));
                            }
                        }
                        else
                        {
                            var fieldValue = dataItem[column.field];

                            var format = column.format;
                            var values = column.values;

                            if (values !== undefined && values != null)
                            {
                                // use the text value mappings (for enums)
                                for (var j = 0; j < values.length; j++)
                                {
                                    var value = values[j];
                                    if (value.value == fieldValue)
                                    {
                                        cell.html(value.text);
                                        break;
                                    }
                                }
                            }
                            else if (format !== undefined)
                            {
                                // use the format
                                cell.html(kendo.format(format, fieldValue));
                            }
                            else
                            {
                                // Just dump the plain old value
                                cell.html(fieldValue);
                            }
                        }
                    }
                }
                else if (colGroup.length == 2)
                {
                    //there's frozen column
                    let frozenColCount = $(colGroup[0]).children('td[role="gridcell"]').length;
                    let normalColCount = $(colGroup[1]).children('td[role="gridcell"]').length;
                    let dataItem = grid.dataItem(colGroup[0]);

                    for (var i = 0; i < grid.columns.length; i++)
                    {
                        var column = grid.columns[i];
                        var template = column.template;
                        var cell = null;

                        if (i >= frozenColCount)
                        {
                            cell = $(colGroup[1]).children('td[role="gridcell"]').eq(i - frozenColCount);
                        }
                        else
                        {
                            cell = $(colGroup[0]).children('td[role="gridcell"]').eq(i);
                        }

                        if (template !== undefined)
                        {
                            var kendoTemplate = kendo.template(template);

                            if (template.contains("'checkbox'"))
                            {
                                //render the cell, special handle for angular event like ng-click
                                cell.html($compile(kendoTemplate(dataItem))(cell.scope().$parent));
                            }
                            else
                            {
                                //render the cell
                                cell.html(kendoTemplate(dataItem));
                            }
                        }
                        else
                        {
                            var fieldValue = dataItem[column.field];

                            var format = column.format;
                            var values = column.values;

                            if (values !== undefined && values != null)
                            {
                                // use the text value mappings (for enums)
                                for (var j = 0; j < values.length; j++)
                                {
                                    var value = values[j];
                                    if (value.value == fieldValue)
                                    {
                                        cell.html(value.text);
                                        break;
                                    }
                                }
                            }
                            else if (format !== undefined)
                            {
                                // use the format
                                cell.html(kendo.format(format, fieldValue));
                            }
                            else
                            {
                                // Just dump the plain old value
                                cell.html(fieldValue);
                            }
                        }
                    }
                }
            }

            //custom fix for grid unable drag and resize column after zoom
            kendo.ui.Grid.prototype._positionColumnResizeHandle = function ()
            {
                var that = this,
                    indicatorWidth = that.options.columnResizeHandleWidth,
                    lockedHead = that.lockedHeader ? that.lockedHeader.find("thead:first") : $();

                that.thead.add(lockedHead).on("mousemove" + ".kendoGrid", "th", function (e)
                {
                    var th = $(this);
                    if (th.hasClass("k-group-cell") || th.hasClass("k-hierarchy-cell"))
                    {
                        return;
                    }
                    that._createResizeHandle(th.closest("div"), th);
                });
            };

            //custom function to get column index by column name
            kendo.ui.Grid.prototype.getColumnIndexByName = function (columnName)
            {
                var index = -1;
                var grid = this;
                var columns = grid.options.columns;
                if (columns.length > 0)
                {
                    for (var i = 0; i < columns.length; i++)
                    {
                        if (columns[i].field == columnName)
                        {
                            // columns[i].title -- You can also use title property here but for this you have to assign title for all columns
                            index = i;
                        }

                        // check if the column is grouped
                        if (columns[i].columns !== undefined && columns[i].columns.length > 0)
                        {
                            for (var j = 0; j < columns[i].columns.length; j++)
                            {
                                if (columns[i].columns[i].field == columnName)
                                {
                                    // columns[i].title -- You can also use title property here but for this you have to assign title for all columns
                                    index = i + j; // because the column index in a row is not grouped, the counting is continued inside the grouping
                                }
                            }
                        }
                    }
                }
                if (index !== -1)
                {
                    return index;
                }
                return index;
            }

            //custom function to select a row (even if it is in different page) by value
            kendo.ui.Grid.prototype.selectRowByKeyValue = function (idField, idValue)
            {
                var dataSource = this.dataSource;
                var filters = dataSource.filter() || {};
                var sort = dataSource.sort() || {};
                var models = dataSource.data();
                // We are using a Query object to get a sorted and filtered representation of the data, without paging applied, so we can search for the row on all pages
                var query = new kendo.data.Query(models);
                var rowNum = 0;
                var modelToSelect = null;

                models = query.filter(filters).sort(sort).data;

                // Now that we have an accurate representation of data, let's get the item position
                for (var i = 0; i < models.length; ++i)
                {
                    var model = models[i];
                if (model[idField] == idValue)
                {
                        modelToSelect = model;
                        rowNum = i;
                        break;
                    }
                }

                // If you have persistSelection = true and want to clear all existing selections first, uncomment the next line
                // this._selectedIds = {};

                // Now go to the page holding the record and select the row
                var currentPageSize = this.dataSource.pageSize();
                var pageWithRow = parseInt((rowNum / currentPageSize)) + 1; // pages are one-based
                this.dataSource.page(pageWithRow);

                var row = this.element.find("tr[data-uid='" + modelToSelect.uid + "']");
                if (row.length > 0)
                {
                    this.select(row);

                    // Scroll to the item to ensure it is visible
                    this.content.scrollTop(this.select().position().top);
                }
            }

            //custom kendo data source function
            kendo.data.DataSource.prototype.getItemsbyCompKey = function (CompKey)
            {
                return (this.data().reduce((prev, current) =>
                {
                    if (current.CompKey == CompKey)
                    {
                        prev.push(current.toJSON());
                    }

                    return prev;
                }, []));
            };

            kendo.data.DataSource.prototype.IsSubjectRequireApproval = function (Subject, ClientKey, CompKey, OUKey, DeptKey, Amount)
            {
                return (this.data().toJSON().findIndex(x =>
                    x.Subject == Subject
                    && (x.ClientKey == ClientKey || x.CompKey == CompKey || x.OUKey == OUKey || x.DeptKey == DeptKey)
                    && (x.ApprovalPolicy == "level" || x.ApprovalPolicy == "levelamount" || ((x.ApprovalPolicy == "amount" || x.ApprovalPolicy == "amountlevel") && ((x.LowerLimit == 0 && x.LowerLimit <= Amount) || (x.LowerLimit != 0 && x.LowerLimit < Amount)) && Amount <= x.UpperLimit))
                )) >= 0;
            }

            kendo.data.DataSource.prototype.getCompKeybyOUKey = function (OUKey)
            {
                let item = this.data().find(x => x.OUKey == OUKey);

                if (typeof item != "undefined")
                {
                    return item.CompKey;
                }
                else
                {
                    return -1;
                }
            }

            kendo.data.DataSource.prototype.getItemsbyOUKey = function (OUKey)
            {
                return (this.data().reduce((prev, current) =>
                {
                    if (current.OUKey == OUKey)
                    {
                        prev.push(current.toJSON());
                    }

                    return prev;
                }, []));
            };

            kendo.data.DataSource.prototype.getItemsbyFilter = function (filter)
            {
                //clear filter to get full set of data
                let tmpDataSource = this.customClone(false, false);

                tmpDataSource.filter(filter);

                return tmpDataSource._view;
            };

            kendo.data.DataSource.prototype.getItemsbyKeyValuePair = function (Key, Value)
            {
                return (this.data().reduce((prev, current) =>
                {
                    if (current[Key] == Value)
                    {
                        prev.push(current.toJSON());
                    }

                    return prev;
                }, []));
            };

            kendo.data.DataSource.prototype.readWithURL = function (url, model)
            {
                let that = this;

                return new Promise(function (resolve, reject)
                {
                    try
                    {
                        if (model !== undefined)
                        {
                            that.options.schema.model = model;
                        }

                        if (url !== undefined)
                        {
                            if (url.indexOf("ExRateInfo") === -1)
                            {
                                that.transport.options.read.url = url;

                                that.read().then(function ()
                                {
                                    resolve();
                                }, function ()
                                {
                                    reject();
                                });
                            }
                            else
                            {
                                _getData("ou").then(function (data)
                                {
                                    let oukey = url.replace(/\s/g, "").substring(url.indexOf("OUKey=") + 6).replace(/\D/g, '');
                                    let compkey = "-1";

                                    let IsMultiCurrency = true;
                                    let LocalCurrKey = "-1"
                                    let LocalCurrCode = "";
                                    let LocalCurrDesc = "";
                                    let LocalCurrSymb = "";

                                    let cachedlen = data.length;
                                    for (var i = 0; i < cachedlen; i++)
                                    {
                                        if (data[i].OUKey.toString() === oukey)
                                        {
                                            compkey = data[i].CompKey.toString();
                                            break;
                                        }
                                    }

                                    if (compkey !== "-1")
                                    {
                                        _getData("currinfo").then(function (data1)
                                        {
                                            let cachedlen1 = data1.length;
                                            for (var j = 0; j < cachedlen1; j++)
                                            {
                                                if (data1[j].CompKey.toString() === compkey)
                                                {
                                                    IsMultiCurrency = data1[j].IsMultiCurrency;
                                                    LocalCurrKey = data1[j].LocalCurrKey;
                                                    LocalCurrCode = data1[j].LocalCurrCode;
                                                    LocalCurrDesc = data1[j].LocalCurrDesc;
                                                    LocalCurrSymb = data1[j].LocalCurrSymb;
                                                    break;
                                                }
                                            }

                                            if (IsMultiCurrency)
                                            {
                                                that.transport.options.read.url = url;

                                                that.read().then(function ()
                                                {
                                                    resolve();
                                                }, function ()
                                                {
                                                    reject();
                                                });
                                            }
                                            else
                                            {
                                                //here hardcode data
                                                that.data(JSON.parse('[{"ClientKey":0,"CurrKey":' + LocalCurrKey.toString() + ',"ExRate":"1","LocalExRate":"1","CurrCode":"' + LocalCurrCode.toString() + '","CurrSymb":"' + LocalCurrSymb.toString() + '","CurrDesc":"' + LocalCurrDesc.toString() + '","CurrCodeCurrDesc":"' + LocalCurrDesc.toString() + '"}]'));
                                                resolve();
                                            }
                                        }, function ()
                                        {
                                            that.transport.options.read.url = url;

                                            that.read().then(function ()
                                            {
                                                resolve();
                                            }, function ()
                                            {
                                                reject();
                                            });
                                        });
                                    }
                                    else
                                    {
                                        that.transport.options.read.url = url;

                                        that.read().then(function ()
                                        {
                                            resolve();
                                        }, function ()
                                        {
                                            reject();
                                        });
                                    }
                                }, function ()
                                {
                                    that.transport.options.read.url = url;

                                    that.read().then(function ()
                                    {
                                        resolve();
                                    }, function ()
                                    {
                                        reject();
                                    });
                                });
                            }
                        }
                        else
                        {
                            that.transport.options.read.url = url;

                            that.read().then(function ()
                            {
                                resolve();
                            }, function ()
                            {
                                reject();
                            });
                        }
                    }
                    catch (ex)
                    {
                        that.transport.options.read.url = url;

                        that.read().then(function ()
                        {
                            resolve();
                        }, function ()
                        {
                            reject();
                        });
                    }
                });
            };

            kendo.data.DataSource.prototype.customClone = function (enablePageSize, enableFilter)
            {
                try
                {
                    let SourceData = this;

                    if (typeof SourceData !== "undefined")
                    {
                        let DataSource = kendo.data.DataSource.create({
                            batch: SourceData.options.batch,
                            serverAggregates: SourceData.options.serverAggregates,
                            serverFiltering: SourceData.options.serverFiltering,
                            serverGrouping: SourceData.options.serverGrouping,
                            serverPaging: SourceData.options.serverPaging,
                            serverSorting: SourceData.options.serverSorting,
                            type: SourceData.options.type,
                            transport: SourceData.options.transport,
                            schema: SourceData.options.schema,
                            pageSize: (enablePageSize === true && typeof SourceData.pageSize() !== "undefined") ? SourceData.pageSize() : void 0,
                            filter: (enableFilter === true && typeof SourceData.filter() !== "undefined") ? _.cloneDeep(SourceData.filter()) : void 0
                        });

                        DataSource.data(SourceData.data().toJSON());

                        return DataSource
                    }
                    else
                    {
                        return (new kendo.data.DataSource());
                    }
                }
                catch (err)
                {
                    console.log(err);
                    return (new kendo.data.DataSource());
                }
            };

            kendo.data.DataSource.prototype.filterCCID = async function (OUKey, AccKey, showAllOU)
            {
                let filter = { logic: "and", filters: [] };
                const AccInfo = (AccKey == -1) ? (void 0) : ((await _getData("coa")).find((element) => element.AccKey == AccKey) ?? (await _getData("facoa")).find((element) => element.AccKey == AccKey));
                if (typeof AccInfo != "undefined")
                {
                    //filter by Cost Center Type
                    filter.filters.push({
                        field: "CCTypeCodeList",
                        operator: _OpContains,
                        value: AccInfo.CostCenterType
                    });

                    //filter by Crop Type
                    if (AccInfo.CostCenterType === "Mature Block"
                        || AccInfo.CostCenterType === "New Planting Block"
                        || AccInfo.CostCenterType === "Replanting Block"
                        || AccInfo.CostCenterType === "Felling Block"
                        || AccInfo.CostCenterType === "Nursery Batch")
                    {
                        filter.filters.push({
                            field: "CropKey",
                            operator: "eq",
                            value: AccInfo.CropKey
                        });
                    }

                    //filter by Account
                    if (!(AccInfo.CostCenterType === "Fixed Asset"
                        || AccInfo.CostCenterType === "Store"
                        || AccInfo.CostCenterType === "Mature Block"
                        || AccInfo.CostCenterType === "New Planting Block"
                        || AccInfo.CostCenterType === "Replanting Block"
                        || AccInfo.CostCenterType === "Felling Block"
                        || AccInfo.CostCenterType === "Nursery Batch"))
                    {
                        filter.filters.push({
                            field: "AccList",
                            operator: _OpContains,
                            value: AccInfo.AccKey
                        });
                    }

                    //filter by Operating Unit
                    if (!(showAllOU === true))
                    {
                        filter.filters.push({
                            field: "OUList",
                            operator: _OpContains,
                            value: OUKey
                        });
                    }
                }
                else
                {
                    filter.filters.push({
                        field: "CCIDKey",
                        operator: "eq",
                        value: -1
                    });
                }

                if (JSON.stringify(filter) !== JSON.stringify(this.filter()))
                {
                    this.filter(filter);
                }
            };

            //custom function to trick combobox to switch to correct page
            if (typeof kendo.ui.ComboBox.prototype.kendoDefaultValueFunction == "undefined")
            {
                kendo.ui.ComboBox.prototype.kendoDefaultValueFunction = kendo.ui.ComboBox.prototype.value;

                kendo.ui.ComboBox.prototype.value = function ()
                {
                    // Call the original filter function.
                    var result = kendo.ui.ComboBox.prototype.kendoDefaultValueFunction.apply(this, arguments);

                    //assign value to combobox
                    if (arguments.length > 0)
                    {
                        if (typeof arguments[0] !== "undefined")
                        {
                            if (arguments[0] !== null)
                            {
                                if (arguments[0] !== "")
                                {
                                    this.trigger('open');
                                }
                            }
                        }
                    }

                    return result;
                }
            }

            //custom function to trick dropdown to switch to correct page
            if (typeof kendo.ui.DropDownList.prototype.kendoDefaultValueFunction == "undefined")
            {
                kendo.ui.DropDownList.prototype.kendoDefaultValueFunction = kendo.ui.DropDownList.prototype.value;

                kendo.ui.DropDownList.prototype.value = function ()
                {
                    // Call the original filter function.
                    var result = kendo.ui.DropDownList.prototype.kendoDefaultValueFunction.apply(this, arguments);

                    //assign value to DropDownList
                    if (arguments.length > 0)
                    {
                        if (typeof arguments[0] !== "undefined")
                        {
                            if (arguments[0] !== null)
                            {
                                if (arguments[0] !== "")
                                {
                                    this.trigger('open');
                                }
                            }
                        }
                    }

                    return result;
                }
            }
        }

        return _initializeCustomKendoFunction;
    }());

    //speed test function
    let _speedTestAPI = function ()
    {
        return new Promise((resolve, reject) =>
        {
            let startTime = performance.now();
            $http.get($rootScope.httpName + $rootScope.quartoDNS + "/api/SpeedTest/GetPayload", { timeout: 60000 }).then(() =>
            {
                //cheat a bit to compensate for processing time
                let elapsedTime = performance.now() - startTime;
                let cheat = elapsedTime - (elapsedTime * 0.2);
                resolve(cheat);
            }, () => reject());
        });
    };

    let _filterOutliers = function (someArray)
    {
        try
        {
            // Copy the values, rather than operating on references to existing values
            let values = someArray.concat();

            // Then sort
            values.sort(function (a, b)
            {
                return a - b;
            });

            /* Then find a generous IQR. This is generous because if (values.length / 4)
             * is not an int, then really you should average the two elements on either
             * side to find q1.
             */
            let q1 = values[Math.floor((values.length / 4))];
            // Likewise for q3.
            let q3 = values[Math.ceil((values.length * (3 / 4)))];
            let iqr = q3 - q1;

            // Then find min and max values
            let maxValue = q3 + iqr * 1.5;
            let minValue = q1 - iqr * 1.5;

            // Then filter anything beyond or beneath these values.
            let filteredValues = values.filter(function (x)
            {
                return (x <= maxValue) && (x >= minValue);
            });

            // Then return
            return filteredValues;
        }
        catch
        {
            return someArray.concat();
        }
    };

    let _speedTest = function ()
    {
        return new Promise((resolve, reject) =>
        {
            console.log("%cStarting speed test. Please wait...", 'background:blue;color:#fff');
            //perform multiple tests to get average
            //each response should be about 5MB in size
            //start one test after another one done to avoid traffic jam affecting result
            _speedTestAPI().then((res0) =>
            {
                _speedTestAPI().then((res1) =>
                {
                    _speedTestAPI().then((res2) =>
                    {
                        _speedTestAPI().then((res3) =>
                        {
                            _speedTestAPI().then((res4) =>
                            {
                                _speedTestAPI().then((res5) =>
                                {
                                    _speedTestAPI().then((res6) =>
                                    {
                                        _speedTestAPI().then((res7) =>
                                        {
                                            _speedTestAPI().then((res8) =>
                                            {
                                                _speedTestAPI().then((res9) =>
                                                {
                                                    _speedTestAPI().then((res10) =>
                                                    {
                                                        _speedTestAPI().then((res11) =>
                                                        {
                                                            _speedTestAPI().then((res12) =>
                                                            {
                                                                _speedTestAPI().then((res13) =>
                                                                {
                                                                    _speedTestAPI().then((res14) =>
                                                                    {
                                                                        _speedTestAPI().then((res15) =>
                                                                        {
                                                                            _speedTestAPI().then((res16) =>
                                                                            {
                                                                                _speedTestAPI().then((res17) =>
                                                                                {
                                                                                    _speedTestAPI().then((res18) =>
                                                                                    {
                                                                                        _speedTestAPI().then((res19) =>
                                                                                        {
                                                                                            _speedTestAPI().then((res20) =>
                                                                                            {
                                                                                                let ResultWithoutOutlier = _filterOutliers([res0, res1, res2, res3, res4, res5, res6, res7, res8, res9, res10, res11, res12, res13, res14, res15, res16, res17, res18, res19, res20]);
                                                                                                let averageTimeInS = (ResultWithoutOutlier.reduce((a, b) => a + b, 0) / ResultWithoutOutlier.length) / 1000;
                                                                                                let averageSpeedInMbps = ((5000000 / averageTimeInS) / 125000).NtoDP(4);

                                                                                                console.log("%cSpeed test success. Payload fetched in average speed of " + averageSpeedInMbps + "Mbps", 'background:blue;color:#fff');

                                                                                                resolve(averageSpeedInMbps);
                                                                                            }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                                                                        }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                                                                    }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                                                                }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                                                            }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                                                        }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                                                    }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                                                }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                                            }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                                        }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                                    }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                                }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                            }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                        }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                    }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                                }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                            }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                        }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                    }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
                }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
            }, () => { console.log("%cSpeed test failed. Please make sure you have a stable internet connection and try again.", 'background:red;color:#fff'); reject(); });
        });
    };

    //debug test
    let _gameStarted = false;
    let _devTest = function (parameter, type)
    {
        if (typeof parameter !== "number")
        {
            console.log("%cParameter:", 'background:red;color:#fff');
            console.log("1 : Evict cache in IndexedDB. Pass in second parameter to specify type or leave blank to evict all.");
            console.log("2 : Evict cache in IndexedDB for all user in current client. Pass in second parameter to specify type or leave blank to evict all.");
            console.log("3 : Evict cache in IndexedDB for all user in every client. Pass in second parameter to specify type or leave blank to evict all.");
            console.log("4 : Force all user in current client to logout.");
            console.log("5 : Force all user in every client to logout.");
            console.log("6 : Post current user's JS performance log.");
            console.log("7 : Post all user's JS performance log.");
            console.log("8 : Refresh cache. Pass in second parameter to specify type or leave blank to show whole list.");
        }
        else
        {
            switch (parameter)
            {
                case 1:
                    _evictCache(type);
                    break;
                case 2:
                    if ($rootScope.getConnectionState("main") === $.signalR.connectionState.connected)
                    {
                        try
                        {
                            $rootScope.broadcastEvictSignal((type === "" || typeof type !== "string") ? "" : type, "");
                        }
                        catch { }
                    }
                    break;
                case 3:
                    if ($rootScope.getConnectionState("main") === $.signalR.connectionState.connected)
                    {
                        try
                        {
                            $rootScope.broadcastEvictSignal((type === "" || typeof type !== "string") ? "" : type, "ALL");
                        }
                        catch { }
                    }
                    break;
                case 4:
                    if ($rootScope.getConnectionState("main") === $.signalR.connectionState.connected)
                    {
                        try
                        {
                            $rootScope.broadcastLogoutSignal("client");
                        }
                        catch { }
                    }
                    break;
                case 5:
                    if ($rootScope.getConnectionState("main") === $.signalR.connectionState.connected)
                    {
                        try
                        {
                            $rootScope.broadcastLogoutSignal("everyone");
                        }
                        catch { }
                    }
                    break;
                case 6:
                    if ($rootScope.getConnectionState("main") === $.signalR.connectionState.connected)
                    {
                        try
                        {
                            _postPerfDBLog();
                        }
                        catch { }
                    }
                    break;
                case 7:
                    if ($rootScope.getConnectionState("main") === $.signalR.connectionState.connected)
                    {
                        try
                        {
                            $rootScope.invokeJSPerfLogCollection().then(function (result)
                            {
                                console.log(esult === true ? "Collection invoked." : "Collection failed.");
                            }, function (error)
                            {
                                console.log("Collection failed.");
                            });
                        }
                        catch { }
                    }
                    break;
                case 8:
                    if (typeof type != "number")
                    {
                        if (typeof clear === "function")
                        {
                            clear();
                        }

                        console.log("%cThis will queue a request to refresh selected cached data in every PC online in CURRENT client.", 'background:red;color:#fff');
                        console.log("%cParameter:", 'background:red;color:#fff');
                        console.log("1.Unit of Measurement");
                        console.log("2.Payment Term");
                        console.log("3.CC ID (Exclude FA)");
                        console.log("4.Currency/Exchange Rate");
                        console.log("5.GRNI Account Information");
                        console.log("6.Bank Setup");
                        console.log("7.Cash Setup");
                        console.log("8.Operating Unit Setup");
                        console.log("9.Chart of Account (Exclude FA)");
                        console.log("10.Contact Setup");
                        console.log("11.Block Setup (All)");
                        console.log("12.Activity Setup");
                        console.log("13.Company Setup");
                        console.log("14.Gang Setup");
                        console.log("15.Employee Setup/Staff Setup");
                        console.log("16.Pay Code Setup");
                        console.log("17.Mill Setup");
                        console.log("18.Vehicle Setup");
                        console.log("19.Attendance Setup");
                        console.log("20.Position Setup");
                        console.log("21.Division Setup");
                        console.log("22.Store Setup");
                        console.log("23.Item Category Setup");
                        console.log("24.Item Setup");
                        console.log("25.Plant Source Setup");
                        console.log("26.Nursery Batch Setup");
                        console.log("27.Plant Mate Setup");
                        console.log("28.Department Setup");
                        console.log("29.Additional Renumeration Setup");
                        console.log("30.Tax Deduction Setup");
                        console.log("31.Approval Level Setup");
                        console.log("32.Account Category Setup");
                        console.log("33.Account Setting");
                        console.log("34.Tax Setup");
                        console.log("35.Terrain Setup");
                        console.log("36.Soil Type Setup");
                        console.log("37.Uncultivated Area Setup");
                        console.log("38.Budget");
                        console.log("39.Chart of Account (Only FA)");
                        console.log("40.CC ID (Only FA)");
                        console.log("41.Chart of Account (All)");
                        console.log("42.CC ID (All)");
                        console.log("43.Field Setup");
                        console.log("44.Inventory Setting");
                        console.log("45.Produce Type Setup");
                        console.log("46.Produce Setup");
                        console.log("47.Sales Item Setup");
                        console.log("48.Notification");
                        console.log("49.Weighing Item Setup");
                        console.log("50.Test Component Type Setup");
                        console.log("51.Test Component Setup");
                        console.log("52.E-Invoice : Classification");
                    }
                    else
                    {
                        if ($rootScope.getConnectionState("main") === $.signalR.connectionState.connected)
                        {
                            try
                            {
                                let _type = "";
                                _type = type == 1 ? "uom" : _type;
                                _type = type == 2 ? "payterm" : _type;
                                _type = type == 3 ? "ccid" : _type;
                                _type = type == 4 ? "currinfo" : _type;
                                _type = type == 5 ? "grniacc" : _type;
                                _type = type == 6 ? "bank" : _type;
                                _type = type == 7 ? "cash" : _type;
                                _type = type == 8 ? "ou" : _type;
                                _type = type == 9 ? "coa" : _type;
                                _type = type == 10 ? "contact" : _type;
                                _type = type == 11 ? "block" : _type;
                                _type = type == 12 ? "activity" : _type;
                                _type = type == 13 ? "company" : _type;
                                _type = type == 14 ? "gang" : _type;
                                _type = type == 15 ? "empy" : _type;
                                _type = type == 16 ? "paycode" : _type;
                                _type = type == 17 ? "mill" : _type;
                                _type = type == 18 ? "vehicle" : _type;
                                _type = type == 19 ? "attdcode" : _type;
                                _type = type == 20 ? "post" : _type;
                                _type = type == 21 ? "div" : _type;
                                _type = type == 22 ? "store" : _type;
                                _type = type == 23 ? "itemcat" : _type;
                                _type = type == 24 ? "itemmas" : _type;
                                _type = type == 25 ? "plantsource" : _type;
                                _type = type == 26 ? "nurbatch" : _type;
                                _type = type == 27 ? "plantmate" : _type;
                                _type = type == 28 ? "dept" : _type;
                                _type = type == 29 ? "addrem" : _type;
                                _type = type == 30 ? "taxded" : _type;
                                _type = type == 31 ? "aprvlvl" : _type;
                                _type = type == 32 ? "acccat" : _type;
                                _type = type == 33 ? "fin" : _type;
                                _type = type == 34 ? "tax" : _type;
                                _type = type == 35 ? "terrain" : _type;
                                _type = type == 36 ? "soiltype" : _type;
                                _type = type == 37 ? "uncularea" : _type;
                                _type = type == 38 ? "bgtprep" : _type;
                                _type = type == 39 ? "facoa" : _type;
                                _type = type == 40 ? "faccid" : _type;
                                _type = type == 41 ? "allcoa" : _type;
                                _type = type == 42 ? "allccid" : _type;
                                _type = type == 43 ? "field" : _type;
                                _type = type == 44 ? "stoconfg" : _type;
                                _type = type == 45 ? "vegetype" : _type;
                                _type = type == 46 ? "vege" : _type;
                                _type = type == 47 ? "salesitem" : _type;
                                _type = type == 48 ? "clientnotification" : _type;
                                _type = type == 49 ? "wgitem" : _type;
                                _type = type == 50 ? "type" : _type;
                                _type = type == 51 ? "typeID" : _type;
                                _type = type == 52 ? "class" : _type;
                                _type = type == 53 ? "bgt" : _type;
                                _type = type == 54 ? "blocktask" : _type;

                                if (_type != "")
                                {
                                    $rootScope.broadcastEvictSignal(_type, "");
                                }

                                console.log("%cRequest triggered successfully, might take some time to reflect depending on server load.", 'background:red;color:#fff');
                            }
                            catch
                            {
                                console.log("%cRequest failed to trigger.", 'background:red;color:#fff');
                            }
                        }
                        else
                        {
                            console.log("%cSignalR not connected, please reload and try again.", 'background:red;color:#fff');
                        }
                    }
                    break;
                case 997:
                    if ($rootScope.getConnectionState("main") === $.signalR.connectionState.connected && typeof (type) === "string" && !(!type || !type.trim()))
                    {
                        try
                        {
                            $http({ url: $rootScope.masterWebApiUrl + "QuartoView/GetDebugUser?UserEmail=" + type.trim(), method: 'GET', jsonp: false, dataType: "json" }).then(function (result)
                            {
                                if (result && result.data && result.data.Token)
                                {
                                    StorageUtils.Session.TrySet("authentication", JSON.stringify(
                                        {
                                            ...JSON.parse(StorageUtils.Session.TryGet("authentication")),
                                            ApproveCRBy: result.data.UserInfo.ApproveCRBy,
                                            ApprovePRBy: result.data.UserInfo.ApprovePRBy,
                                            ClientKey: result.data.UserInfo.ClientKey,
                                            MasterNoPolicy: result.data.UserInfo.MasterNoPolicy,
                                            TimeZoneOffset: result.data.UserInfo.TimeZoneOffset,
                                            WBWtDisplayMtd: result.data.UserInfo.WBWtDisplayMtd,
                                            clientID: result.data.UserInfo.ClientID,
                                            defaultCompKey: result.data.UserInfo.DefaultCompKey,
                                            defaultDeptKey: result.data.UserInfo.DefaultDeptKey,
                                            defaultOUCode: result.data.UserInfo.DefaultOUCode,
                                            defaultOUKey: result.data.UserInfo.DefaultOUKey,
                                            email: result.data.UserInfo.UserEmail,
                                            enableBaitulmal: result.data.UserInfo.EnableBaitulmal,
                                            isAuth: true,
                                            isAutomatedOUAllocation: result.data.UserInfo.IsAutomatedOUAllocation,
                                            isLMStaff: true,
                                            isShowAddRemEPF: result.data.UserInfo.IsShowAddRemEPF,
                                            isShowDivider: result.data.UserInfo.IsShowDivider,
                                            isTaxContCompulsory: result.data.UserInfo.IsTaxContCompulsory,
                                            isTaxEditable: result.data.UserInfo.IsTaxEditable,
                                            token: result.data.Token.replace("Bearer ", ""),
                                            userID: result.data.UserInfo.UserID,
                                            userKey: result.data.UserInfo.UserKey,
                                            userName: result.data.UserInfo.UserName,
                                            epfDeductionMtdForPCB: result.data.UserInfo.EPFDeductionMtdForPCB
                                        }));
                                    console.log("Please reload, and please logout (click logout, not close browser) after use!");
                                }
                            });
                        } catch { }
                    }
                    break;
                case 999:
                    if (!_gameStarted)
                    {
                        _gameStarted = true;
                        var EasterDiv = document.createElement("div"); EasterDiv.id = "EasterEgg"; EasterDiv.style.display = "inline-table"; EasterDiv.style.width = "100%"; document.getElementById("mainContainer").append(EasterDiv);
                        $("#EasterEgg").kendoWindow({ actions: ["Close"], title: "Tic Tac Toe", resizable: false, visible: false, modal: true, draggable: true, animation: false });
                        var div1 = document.createElement("div"); div1.id = "tictactoe"; document.getElementById("EasterEgg").appendChild(div1); var div2 = document.createElement("div"); div2.id = "tictactoe_msg"; div2.align = "left"; document.getElementById("EasterEgg").appendChild(div2); var dateSpan = document.createElement('span'); dateSpan.id = "turn"; dateSpan.innerHTML = "Player X"; document.getElementById("tictactoe_msg").appendChild(dateSpan);
                        var N_SIZE = 3, EMPTY = "&nbsp;", boxes = [], turn = "X", score, moves;
                        function init() { var board = document.createElement('table'); board.style["border-collapse"] = "collapse"; board.setAttribute("border", 1); board.setAttribute("cellspacing", 0); var identifier = 1; for (var i = 0; i < N_SIZE; i++) { var row = document.createElement('tr'); board.appendChild(row); for (var j = 0; j < N_SIZE; j++) { var cell = document.createElement('td'); cell.style["background-color"] = "black"; cell.style["border"] = "3px solid white"; cell.style["font-size"] = "80px"; cell.style["color"] = "#ffffff"; cell.style["border-radius"] = "10px 10px 10px 10px"; cell.setAttribute('height', 120); cell.setAttribute('width', 120); cell.setAttribute('align', 'center'); cell.setAttribute('valign', 'center'); cell.classList.add('col' + j, 'row' + i); if (i == j) { cell.classList.add('diagonal0'); } if (j == N_SIZE - i - 1) { cell.classList.add('diagonal1'); } cell.identifier = identifier; cell.addEventListener("click", set); row.appendChild(cell); boxes.push(cell); identifier += identifier; } } document.getElementById("tictactoe").appendChild(board); startNewGame(); }
                        function startNewGame() { score = { "X": 0, "O": 0 }; moves = 0; turn = "X"; boxes.forEach(function (square) { square.innerHTML = EMPTY; }); }
                        function win(clicked) { var memberOf = clicked.className.split(/\s+/); for (var i = 0; i < memberOf.length; i++) { var testClass = '.' + memberOf[i]; var items = contains('#tictactoe ' + testClass, turn); if (items.length == N_SIZE) { return true; } } return false; }
                        function contains(selector, text) { var elements = document.querySelectorAll(selector); return [].filter.call(elements, function (element) { return RegExp(text).test(element.textContent); }); }
                        function set() { if (this.innerHTML !== EMPTY) { return; } this.innerHTML = turn; moves += 1; score[turn] += this.identifier; if (win(this)) { alert('Winner: Player ' + turn); startNewGame(); } else if (moves === N_SIZE * N_SIZE) { alert("Draw"); startNewGame(); } else { turn = turn === "X" ? "O" : "X"; document.getElementById('turn').textContent = 'Player ' + turn; } }
                        init();
                    }
                    $('#EasterEgg').data('kendoWindow').center().open();
                    break;
                case 998:
                    if (!_gameStarted)
                    {
                        _gameStarted = true;
                        var EasterDiv = document.createElement("div"); EasterDiv.id = "EasterEgg"; EasterDiv.style.display = "inline-table"; EasterDiv.style.width = "100%"; document.getElementById("mainContainer").append(EasterDiv);
                        $("#EasterEgg").kendoWindow({ actions: ["Close"], title: "Minesweeper", resizable: false, visible: false, modal: true, draggable: true, animation: false, iframe: true, width: 770, height: 530, content: "http://radovanjanjic.com/js-minesweeper/", });
                    }
                    $('#EasterEgg').data('kendoWindow').center().open();
                    break;
                default:
                    _devTest();
                    break;
            }
        }
    };

    //expose to rootscope
    $rootScope.GetDataSource = _getCachedDataSource;
    $rootScope.broadcastUpdateSignal = _broadcastUpdateSignal;

    return {
        Cache: {
            getCachedDataSource: _getCachedDataSource,
            getData: _getData,
            broadcastUpdateSignal: _broadcastUpdateSignal,
            receiveUpdateSignal: _receiveUpdateSignal,
            evictOutdatedCache: _evictOutdatedCache,
            evictCache: _evictCache
        },
        Request: {
            getUIInformation: _getUIInformation,
            getReqExRate: function (strQuery)
            {
                return $http({
                    url: $rootScope.financeWebApiUrl + "FIN/GetExRate?" + ((typeof strQuery == "undefined") ? "" : strQuery),
                    method: "GET"
                });
            },
            getReqDocStateChanged: function (strQuery)
            {
                return $http({
                    url: $rootScope.financeWebApiUrl + "FIN/GetIsDocStateChanged?" + ((typeof strQuery == "undefined") ? "" : strQuery),
                    method: "GET"
                });
            },
            getReqYearEndMthStatus: function (strQuery)
            {
                return $http({
                    url: $rootScope.financeWebApiUrl + "FIN/GetFYandMthEndStatus?" + ((typeof strQuery == "undefined") ? "" : strQuery),
                    method: "GET"
                });
            },
            getReqGLHeader: function (strQuery)
            {
                return $http({
                    url: $rootScope.financeOdataUrl + "GLHeader?TransHdrKey=" + ((typeof strQuery == "undefined") ? "" : strQuery) + "&$format=json",
                    method: "GET"
                });
            },
            getDataExRate: function (strQuery)
            {
                let DataSource = new kendo.data.DataSource(
                    {
                        type: "odata",
                        transport:
                        {
                            read:
                            {
                                url: ((typeof strQuery == "undefined") ? "" : strQuery),
                                jsonp: false,
                                dataType: "json"
                            }
                        },
                        schema:
                        {
                            data: function (data)
                            {
                                return _parseStringToDecimal(data["value"]);
                            },
                            total: function (data)
                            {
                                return data["odata.count"];
                            },
                            model:
                            {
                                id: "CurrKey",
                                fields:
                                {
                                    CurrKey: { type: "number", editable: false, nullable: false },
                                    CurrCode: { type: "string", editable: false, nullable: false },
                                    ExRate: { type: "number", editable: false, nullable: false, defaultValue: 0 },
                                    CurrDesc: { type: "string", editable: false, nullable: false },
                                    CurrSymb: { type: "string", editable: false, nullable: false },
                                }
                            }
                        },
                        pageSize: $rootScope.comboBoxPageSize
                    });

                return DataSource;
            },
            getPayeePayerAutoFillDs: function ()
            {
                let DataSource = new kendo.data.DataSource({
                    type: "odata",
                    transport:
                    {
                        read:
                        {
                            url: function ()
                            {
                                return $rootScope.financeWebApiUrl + "FIN/GetPayeePayer?$format=json&$select=PayTo";
                            },
                            method: 'GET',
                            jsonp: false,
                            dataType: "json",
                        }
                    },
                    schema:
                    {
                        data: function (data)
                        {
                            return _parseStringToDecimal(data);
                        },
                        total: function (data)
                        {
                            return data.length;
                        },
                        model:
                        {
                            id: "PayTo",
                            fields: { PayTo: { type: "string", editable: false, nullable: false } }
                        }
                    },
                    pageSize: $rootScope.comboBoxPageSize
                });

                return DataSource;
            },
            getOTVendNameAutoFillDs: function ()
            {
                let DataSource = new kendo.data.DataSource({
                    type: "odata",
                    transport:
                    {
                        read:
                        {
                            url: function ()
                            {
                                return $rootScope.financeWebApiUrl + "FIN/GetOTVendName?$format=json&$select=VendorName,EmpyKey,Street,PostCode,City,State,CtryKey,Phone,Fax";
                            },
                            method: 'GET',
                            jsonp: false,
                            dataType: "json",
                        }
                    },
                    schema:
                    {
                        data: function (data)
                        {
                            return _parseStringToDecimal(data);
                        },
                        total: function (data)
                        {
                            return data.length;
                        },
                        model:
                        {
                            id: "VendorName",
                            fields: {
                                VendorName: { type: "string", editable: false, nullable: false },
                                EmpyKey: { type: "number", editable: false, nullable: false },
                                Street: { type: "string", editable: false, nullable: false },
                                PostCode: { type: "string", editable: false, nullable: false },
                                City: { type: "string", editable: false, nullable: false },
                                State: { type: "string", editable: false, nullable: false },
                                CtryKey: { type: "number", editable: false, nullable: false },
                                Phone: { type: "string", editable: false, nullable: false },
                                Fax: { type: "string", editable: false, nullable: false }
                            }
                        }
                    },
                    pageSize: $rootScope.comboBoxPageSize
                });

                return DataSource;
            },
            getBeneficiaryDs: function ()
            {
                let DataSource = new kendo.data.DataSource({
                    type: "odata",
                    transport:
                    {
                        read:
                        {
                            url: function ()
                            {
                                return $rootScope.masterOdataUrl + "Beneficiary?$format=json&$select=BenKey,BenDesc,Active,BeneficiaryOU";
                            },
                            method: 'GET',
                            jsonp: false,
                            dataType: "json",
                        }
                    },
                    schema:
                    {
                        data: function (data)
                        {
                            return _parseStringToDecimal(data["value"]);
                        },
                        total: function (data)
                        {
                            return data["odata.count"];
                        },
                        model:
                        {
                            id: "BenKey",
                            fields: {
                                BenKey: { type: "number", editable: false, nullable: false },
                                BenDesc: { type: "string", editable: false, nullable: false },
                                Active: { type: "boolean", editable: false, nullable: false },
                                BeneficiaryOU: { type: "object", editable: false, nullable: false },
                            }
                        }
                    },
                    pageSize: $rootScope.comboBoxPageSize
                });

                return DataSource;
            },
        },
        Utility: {
            parseStringToDecimal: _parseStringToDecimal,
            getSessionClientKey: _getSessionClientKey,
            generateRandomID: _generateRandomID,
            generateGUID: _generateGUID,
            initializeCustomKendoFunction: _initializeCustomKendoFunction,
            speedTest: _speedTest,
            devTest: _devTest
        },
        Logging: {
            logGeneralJsError: _logGeneralJsError,
            postPerfDBLog: _postPerfDBLog
        }
    };
}]);